/* eslint-disable */
const translations = {
  th: {
    confirm:        'ยืนยัน',
    cancel:         'ยกเลิก',
    save:           'บันทึก',
    back:           'กลับ',
    close:          'ปิด',
    copy:           'คัดลอก',
    copied:         'คัดลอกแล้ว!',
    loading:        'กำลังโหลด...',
    error:          'เกิดข้อผิดพลาด',
    success:        'สำเร็จ',
    submit:         'ส่ง',
    or:             'หรือ',
    contact:        'ติดต่อ',
    baht:           'บาท',
    ok:             'ตกลง',
    search:         'ค้นหา',
    more:           'ดูเพิ่มเติม',
    no_data:        'ไม่มีข้อมูล',

    home:           'หน้าหลัก',
    deposit:        'ฝากเงิน',
    withdraw:       'ถอนเงิน',
    history:        'ประวัติ',
    promotion:      'โปรโมชั่น',
    affiliate:      'แนะนำเพื่อน',
    cashback:       'คืนยอดเสีย',
    toprank:        'จัดอันดับ',
    redeem_reward:  'แลกของรางวัล',
    rebate:         'คืนยอดเดิมพัน',
    profile:        'ข้อมูลส่วนตัว',
    logout:         'ออกจากระบบ',
    login:          'เข้าสู่ระบบ',
    register:       'สมัครสมาชิก',
    lucky_fortune:  'กงล้อโชคลาภ',
    check_in:       'เช็คอินรายวัน',
    event:          'กิจกรรม',
    casino:         'คาสิโน',
    slot:           'สล็อต',
    fishing:        'ยิงปลา',
    sport:          'กีฬา',
    lotto:          'หวย',
    card_game:      'เกมไพ่',

    menu_home:      'หน้าหลัก',
    menu_deposit:   'ฝาก',
    menu_contact:   'ติดต่อ',
    menu_promotion: 'โปร',
    menu_profile:   'บัญชี',

    login_title:      'เข้าสู่ระบบ',
    login_phone:      'เข้าระบบด้วยเบอร์โทรศัพท์',
    username_label:   'เบอร์โทรศัพท์',
    password_label:   'รหัสผ่าน',
    forgot_password:  'ลืมรหัสผ่าน',
    no_account:       'ยังไม่มีบัญชี?',
    register_now:     'สมัครสมาชิก',
    login_btn:        'เข้าสู่ระบบ',

    register_title:     'สมัครสมาชิก',
    firstname:          'ชื่อ-นามสกุล',
    phone_number:       'เบอร์โทรศัพท์',
    confirm_password:   'ยืนยันรหัสผ่าน',
    invite_code:        'รหัสแนะนำ (ถ้ามี)',
    have_account:       'มีบัญชีอยู่แล้ว?',
    login_now:          'เข้าสู่ระบบ',
    select_bank:        'เลือกธนาคาร',
    account_number_label: 'เลขบัญชีธนาคาร',
    register_btn:       'สมัครสมาชิก',

    deposit_title:      'ฝากเงิน',
    bank_tab:           'ธนาคาร',
    truemoney_tab:      'ทรูมันนี่',
    payment_tab:        'Payment',
    upload_slip_tab:    'อัพโหลดสลิป',
    account_name:       'ชื่อบัญชี',
    bank_name:          'ธนาคาร',
    min_amount:         'ขั้นต่ำ',
    max_amount:         'สูงสุด',
    amount_label:       'จำนวนเงิน (บาท)',
    amount_placeholder: 'กรอกจำนวนเงิน',
    quick_fill:         'กรอกด่วน',
    scan_qr:            'สแกน QR Code ชำระเงิน',
    upload_slip:        'อัพโหลดสลิป',
    drag_drop_text:     'ลากรูปมาวางหรือคลิกเพื่อเลือกไฟล์',
    select_file:        'เลือกไฟล์',
    conditions_title:   'เงื่อนไขการฝากเงิน',
    confirm_deposit:    'ยืนยันการฝากเงิน',
    copy_account:       'คัดลอก',
    deposit_to:         'โอนเงินไปที่',
    upload_success:     'อัพโหลดสำเร็จ!',
    upload_success_desc:'สลิปของคุณถูกส่งเรียบร้อยแล้ว',
    supported_format:   'รองรับ JPG, PNG, WEBP ขนาดไม่เกิน 5MB',
    change_slip:        'เปลี่ยนรูป',
    create_qr:          'สร้าง QR Code เพื่อชำระ',
    confirm_payment:    'ยืนยันการชำระเงิน',
    promptpay_only:     'พร้อมเพย์ / ธนาคารเท่านั้น',
    confirm_upload:     'ยืนยันการอัพโหลด',
    uploading:          'กำลังอัพโหลด...',
    upload_slip_title:  'อัพโหลดสลิป',
    upload_slip_desc:   'แนบหลักฐานการโอนเงิน',
    upload_success_title: 'อัพโหลดสลิปสำเร็จ',
    processing:         'ระบบกำลังตรวจสอบ กรุณารอสักครู่',
    reupload:           'อัพโหลดใหม่',
    upload_conditions_title: 'เงื่อนไขการอัพโหลดสลิป',
    tap_select_image:   'แตะเพื่อเลือกรูปสลิป',
    go_promotion:       'ไปหน้าโปรโมชั่น',

    crypto_tab:         'คริปโต',
    crypto_currency:    'สกุลเงิน',
    crypto_network:     'เครือข่าย',
    crypto_address:     'ที่อยู่กระเป๋า',
    crypto_scan_qr:     'สแกน QR เพื่อโอน',
    crypto_copy:        'คัดลอกที่อยู่',
    crypto_upload_slip: 'แนบหลักฐานการโอน',
    crypto_note:        'หมายเหตุ: โอนให้ตรงสกุลเงินและเครือข่าย มิฉะนั้นเงินจะสูญหาย',
    crypto_rate_note:   'อัตราแลกเปลี่ยนอ้างอิง ณ เวลาที่ทำรายการ',
    crypto_confirm:     'ยืนยันการโอน',

    withdraw_title:    'ถอนเงิน',
    withdraw_amount:   'จำนวนที่ต้องการถอน',
    select_amount:     'เลือกจำนวน',
    withdraw_to:       'ถอนไปที่บัญชี',
    withdraw_min:      'ถอนขั้นต่ำ',
    withdraw_max:      'ถอนสูงสุด',
    available_balance: 'ยอดคงเหลือ',
    confirm_withdraw:  'ยืนยันการถอน',

    profile_title:    'ข้อมูลส่วนตัว',
    account_info:     'ข้อมูลบัญชี',
    fullname:         'ชื่อ-นามสกุล',
    rank:             'ระดับ',
    credit:           'เครดิต',
    point:            'แต้ม',
    change_password:  'เปลี่ยนรหัสผ่าน',
    old_password:     'รหัสผ่านเดิม',
    new_password:     'รหัสผ่านใหม่',
    account_number:   'เลขบัญชี',

    history_title:   'ประวัติธุรกรรม',
    all_type:        'ทั้งหมด',
    deposit_type:    'ฝากเงิน',
    withdraw_type:   'ถอนเงิน',
    bonus_type:      'โบนัส',
    date_col:        'วันที่',
    amount_col:      'จำนวน',
    status_col:      'สถานะ',
    status_approve:  'สำเร็จ',
    status_pending:  'รอดำเนินการ',
    status_reject:   'ปฏิเสธ',

    promotion_title: 'โปรโมชั่น',
    apply_promo:     'รับโปรโมชั่น',
    in_use_promo:    'กำลังใช้งาน',
    promo_full:      'เต็มแล้ว',
    promo_available: 'ว่าง',
    promo_detail:    'รายละเอียด',
    no_promotion:    'ไม่มีโปรโมชั่นที่ใช้งานได้',
    cancel_promo:    'ยกเลิกโปรโมชั่น',
    min_deposit:     'ฝากขั้นต่ำ',
    bonus_percent:   'โบนัส',
    max_withdraw:    'ถอนได้สูงสุด',
    turn_over:       'เทิร์นโอเวอร์',

    affiliate_title: 'แนะนำเพื่อน',
    invite_link:     'ลิงก์แนะนำ',
    today_income:    'รายได้วันนี้',
    total_income:    'รายได้ทั้งหมด',
    member_count:    'จำนวนสมาชิก',
    withdraw_btn:    'ถอนเงิน',
    share_line:      'แชร์ LINE',

    cashback_title:    'คืนยอดเสีย',
    period_label:      'รอบ',
    eligible_amount:   'ยอดเสียที่มีสิทธิ์',
    cashback_rate:     'อัตราคืน',
    receive_cashback:  'รับคืนยอดเสีย',
    cashback_history:  'ประวัติการรับ',

    rebate_title:   'คืนยอดเดิมพัน',
    rebate_amount:  'ยอดเดิมพัน',
    receive_rebate: 'รับคืน',

    toprank_title: 'จัดอันดับ',
    rank_col:      'อันดับ',
    username_col:  'ชื่อผู้ใช้',
    credit_col:    'เครดิต',

    redeem_title:   'แลกของรางวัล',
    redeem_btn:     'แลก',
    my_points:      'แต้มของฉัน',
    required_points:'แต้มที่ต้องใช้',

    spin_btn:       'หมุน',
    spin_free:      'ฟรี',
    spin_remaining: 'ครั้งที่เหลือ',
    checkin_day:    'วันที่',
    checkin_title:  'เช็คอินรายวัน',
    checkin_btn:    'เช็คอิน',
    checkin_done:   'เช็คอินแล้ว',

    language_label:    'Language / ภาษา',
    footer_seo_title:  'คาสิโนออนไลน์เต็มรูปแบบ',
    footer_desc:       'บริการฝาก-ถอนออโต้ตลอด 24 ชั่วโมง',

    event_title: 'กิจกรรม',

    register_phone_subtitle: 'สมัครสมาชิกด้วยเบอร์โทรศัพท์',
    referrer:                'ผู้แนะนำ',
    next:                    'ถัดไป',
    password_step:           'รหัสผ่าน',
    select_bank_title:       'กรุณาเลือกธนาคาร',
    account_no_placeholder:  'เลขบัญชี',
    account_name_placeholder:'ชื่อบัญชี',
    contact_btn:             'ติดต่อ',

    checkin_activity_title:        'กิจกรรมเชคอิน',
    checkin_subtitle:              'รับทุกวันเพียงเข้ามาเช็คอิน พร้อมทั้งสะสมเพื่อรับรางวัลที่สูงขึ้น',
    checkin_min_deposit_prefix:    'ทำยอดเติม',
    checkin_min_deposit_suffix:    '.- ขึ้นไป',
    today:                         'วันนี้',
    checkin_monthly:               'เช็คอินสะสมเดือนนี้',
    max_label:                     'สูงสุด',
    day_unit:                      'วัน',

    my_points_label:    'พ้อยต์ของคุณ',
    reward_items_tab:   'ของรางวัล',
    redeem_history_tab: 'ประวัติการแลก',
    no_rewards_yet:     'ยังไม่มีของรางวัล',
    no_redeem_history:  'ยังไม่มีประวัติการแลก',
    stock_remaining:    'คงเหลือ',
    out_of_stock:       'หมดแล้ว',
    redeem_now:         'แลกเลย',
    not_enough_points:  'พ้อยต์ไม่พอ',

    lucky_wheel_title: 'วงล้อนำโชค',
    spin_wheel_btn:    'หมุนกงล้อ',
    lucky_wheel_alt:           'วงล้อนำโชค กงล้อมหาสนุก',
    invite_success:            'ทำรายการรับเงินเรียบร้อย',
    invite_no_balance:         'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
    action_failed:             'ไม่สามารถทำรายการได้',
    wheel_conditions_title:    'เงื่อนไขการให้บริการ',
    wheel_cond_deposit:        '• ฝากเงินสะสมครบ 1,000 บาท จะได้รับ 1 ตั๋ว (สูงสุด 5 ตั๋ว / วัน)',
    wheel_cond_reset_prefix:   '• ยอดฝากสะสมจะ',
    wheel_cond_reset_value:    'รีเซ็ตเป็น 0',
    wheel_cond_reset_suffix:   'ในเวลา 00.00 น. ของทุกวัน',
    wheel_cond_ticket_note:    '*ตั๋วกงล้อจะถูกคำนวณและได้รับ ต่อเมื่อเข้ามาที่หน้านี้เท่านั้น',
    wheel_cond_no_entry:       'หากไม่เข้าจะไม่ได้รับ',

    popular:          'ยอดนิยม',
    esport:           'อีสปอร์ต',
    slots_popular:    'สล็อตยอดนิยม',
    casino_popular:   'คาสิโนออนไลน์ ยอดนิยม',
    lucky_wheel_short:'กงล้อ',
    open_card:        'เปิดไพ่',
    open_card_event:  'กิจกรรมเปิดไพ่',
    checkin_short:    'เชคอิน',
    loss_cashback:    'รับยอดเสีย',
    loss_short:       'ยอดเสีย',
    deposit_problem:  'หากเกิดปัญหาฝากเงินหรืออื่นๆ กรุณาติดต่อเจ้าหน้าที่',

    trading:          'เทรดดิ้ง',
    play_btn:         'เข้าเล่น',
    not_open_yet:     'ยังไม่เปิด',
    play_game:        'เล่นเกม',

    your_account:       'บัญชีของคุณ',
    transfer_note_only: 'กรุณาโอนเงินด้วยบัญชีที่ระบบแจ้งเท่านั้น',
    bank_dest:          'ธนาคารปลายทาง',
    savings_type:       'ออมทรัพย์',
    acc_no_label:       'เลขที่บัญชี',
    copy_acc_no:        'คัดลอกเลขบัญชี',
    notify_transfer_done: 'แจ้งโอนเงินเรียบร้อย',
    notify_transfer:    'แจ้งโอนเงิน',
    transfer_warning:   'กรุณาแจ้งโอนภายใน 5 นาที หลังโอนเงิน',
    uploading_slip:     'กำลังอัปโหลดสลิป...',
    confirm_upload_btn: 'ยืนยันอัปโหลด',
    payment_channel:    'ช่องทางการชำระเงิน',
    wallet_type:        'วอลเล็ท',
    wallet_number_label:'หมายเลขวอลเล็ท',
    copy_wallet_no:     'คัดลอกเบอร์วอลเล็ท',
    truemoney_warning:  'โอนเงินจากแอป TrueMoney ไปยังเบอร์ข้างต้น แล้วแจ้งโอนผ่าน LINE Admin ระบบจะเติมเครดิตภายใน 5 นาที',

    cond_pay_1: 'กรุณากดยืนยันแล้วชำระเงินภายในเวลาที่กำหนด',
    cond_pay_2: 'หากชำระเงินแล้วเครดิตไม่เข้า กรุณาติดต่อแอดมิน',
    cond_pay_3: 'ห้ามกดปุ่มยืนยันซ้ำโดยไม่จำเป็น',
    cond_slip_1:'อัพโหลดสลิปหลังจากโอนเงินเสร็จเท่านั้น',
    cond_slip_2:'รูปต้องชัดเจน มองเห็นยอดและเวลาการโอน',
    cond_slip_3:'ห้ามอัพโหลดสลิปซ้ำหรือสลิปปลอม',

    qr_for_payment:      'QR Code สำหรับชำระเงิน',
    scan_once_only:      'QR Code สามารถสเเกนจ่ายได้เพียงครั้งเดี่ยวเท่านั้นโปรดอย่าสเเกนจ่ายซ้ำ',
    pay_within_time:     'โปรดชำระเงินภายในเวลาที่กำหนด',
    cancel_transaction:  'ยกเลิกรายการ',
    new_transaction:     'กรุณาทำรายการใหม่',
    payment_via_system:  'ชำระผ่านระบบ Payment',
    min_deposit_note:    'ฝากขั้นต่ำ {min} บาท สูงสุด {max} บาท',
    cond_slip_4:         'ระบบจะตรวจสอบและเติมเครดิตภายใน 5 นาที',
    cond_slip_5:         'หากมีปัญหาติดต่อแอดมินผ่าน Line',
    confirm_transfer:    'ยืนยันการโอน',
    crypto_warning_net:  'โอนให้ตรงสกุลเงินและเครือข่ายที่แสดง มิฉะนั้นเงินจะสูญหายและไม่สามารถกู้คืนได้',
    exchange_rate_note:  'อัตราแลกเปลี่ยนอ้างอิง ณ เวลาที่ทำรายการ',
    game_balance:        'ยอดเงินในเกม',
    mission_label:       'ภารกิจ',
    sec_unit:            'วินาที',
    notify_slip_warning: 'กรุณาแจ้งโอนเงินภายใน 5 นาที หลังจากทำรายการ ระบบจะยกเลิกรายการอัตโนมัติหากเกินเวลา',

    crypto_title_short:  'คริปโต',
    crypto_send_note:    'โอนคริปโตมายังที่อยู่กระเป๋าด้านล่าง',
    select_currency:     'เลือกสกุลเงิน',
    wallet_address_label:'ที่อยู่กระเป๋า',
    min_label_short:     'ขั้นต่ำ',
    max_label_short:     'สูงสุด',
    attach_proof:        'แนบหลักฐานการโอน',
    drag_or_click:       'ลากรูปมาวางหรือคลิกเพื่อเลือก',
    click_to_change:     'คลิกเพื่อเปลี่ยนรูป',

    not_logged_in:           'ยังไม่ได้เข้าสู่ระบบ',
    not_logged_in_text:      'คุณยังไม่ได้ทำการล็อคอิน',
    select_slip_file:        'กรุณาเลือกไฟล์สลิป',
    upload_slip_failed:      'อัปโหลดสลิปไม่สำเร็จ',
    transaction_done:        'ดำเนินการเรียบร้อย',
    transaction_failed:      'ทำรายการไม่สำเร็จ',
    error_occurred:          'เกิดข้อผิดพลาด',
    session_expired:         'Session หมดอายุ กรุณาล็อกอินใหม่',
    game_problem:            'ขณะนี้เกมมีปัญหา กรุณารอซักครู่',
    qr_scan_5min:            'กรุณาสแกน QR Code ภายใน 5 นาที',
    force_withdraw_all:      'บังคับถอนยอดทั้งหมด',
    insufficient_withdraw:   'ยอดถอนของท่านไม่เพียงพอในการถอน',
    withdraw_success:        'รายการถอนเรียบร้อย',
    turnover_remaining_prefix: 'ท่านติด Turnover อีก',
    min_withdraw_prefix:     'ขั้นต่ำในการถอน',
    withdraw_error:          'ไม่สามารถทำรายการถอนได้ โปรดแจ้งพนักงาน',
    withdraw_problem:        'รายการถอนมีปัญหา โปรดติดต่อพนักงาน',
    change_password_success: 'เปลี่ยนรหัสผ่านเรียบร้อย',
    wrong_old_password:      'รหัสผ่านเดิมไม่ถูกต้อง',
    password_error:          'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง',
    same_password:           'รหัสผ่านใหม่ซ้ำกับรหัสเดิม',
    password_mismatch:       'รหัสผ่านไม่ตรงกัน',
    copy_success:            'คัดลอกเรียบร้อย',
    select_file_first:       'กรุณาเลือกไฟล์ก่อนยืนยัน',
    time_expired:            'หมดเวลา',
    hour_unit:               'ชั่วโมง',

    truegift_tab:            'ของขวัญทรูมันนี่',
    no_bank_account:         'ไม่พบบัญชีธนาคาร',
    copy_acc_done:           'คัดลอกเลขบัญชีแล้ว!',
    copy_acc_prefix:         'คัดลอกเลขบัญชี',
    select_deposit_amount:   'เลือกจำนวนเงินที่ต้องการฝาก',
    enter_amount:            'ระบุจำนวนเงิน',
    bank_transfer_warning:   'กรุณาโอนด้วยบัญชีที่ลงทะเบียนไว้เท่านั้น หากโอนจากบัญชีอื่นระบบจะไม่ตรวจจับยอดโอนอัตโนมัติ กรุณาแจ้งโอนผ่าน LINE Admin',
    no_autoslip:             'ไม่พบบัญชี AutoSlip',
    upload_slip_auto_label:  'อัพโหลดสลิป (ระบบตรวจสอบอัตโนมัติ)',
    confirm_upload_slip:     'ยืนยันอัพโหลดสลิป',
    upload_success_checking: 'อัพโหลดสำเร็จ! ระบบกำลังตรวจสอบ...',
    transfer_warning_short:  'กรุณาโอนด้วยบัญชีที่ลงทะเบียนไว้เท่านั้น',
    no_truewallet:           'ไม่พบบัญชีทรูมันนี่',
    truemoney_phone_label:   'เบอร์โทรทรูมันนี่ของคุณ',
    submitting:              'กำลังส่งข้อมูล...',
    notify_truemoney_deposit:'แจ้งฝากทรูมันนี่',
    truemoney_submit_success:'แจ้งฝากทรูมันนี่สำเร็จ กรุณารอตรวจสอบ',
    deposit_gift_truemoney:  'ฝากด้วย Gift TrueMoney',
    gift_paste_hint:         'วางลิ้งค์ Gift จาก gift.truemoney.com แล้วกดส่ง',
    gift_link_label:         'ลิ้งค์ Gift TrueMoney',
    checking:                'กำลังตรวจสอบ...',
    send_gift_link:          'ส่งลิ้งค์ของขวัญ',
    gift_submit_success:     'ส่งลิ้งค์ของขวัญสำเร็จ กรุณารอตรวจสอบ',
    no_payment_gateway:      'ไม่พบ Payment Gateway',
    pay_via_gateway:         'ชำระผ่าน Payment Gateway',
    contact_admin:           'กรุณาติดต่อ Admin',
    no_crypto:               'ไม่พบกระเป๋าคริปโต',
    crypto_thb_label:        'ใส่จำนวนเงิน (บาท) ที่ต้องการโอน',
    crypto_amount_prefix:    'จำนวน',
    crypto_amount_suffix:    'ที่ต้องโอน',
    crypto_send_only:        'กรุณาส่งเฉพาะ',
    crypto_send_only_suffix: 'เท่านั้น',
    crypto_wrong_type_warning:'การส่งสกุลเงินผิดประเภทอาจทำให้สูญเสียทรัพย์สิน',
    load_failed_retry:       'ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่',

    from_last_month:         'จากเดือนที่แล้ว',
    withdrawable_income:     'รายได้ที่ถอนได้',
    members_this_month:      'สมาชิกเดือนนี้',
    new_members_today:       'สมาชิกใหม่วันนี้',
    person_unit:             'คน',
    how_to_build_network:    'วิธีการสร้างเครือข่าย',
    seven_days_filter:       '7 วัน',
    month_filter:            'เดือน',
    new_member_tab:          'สมาชิกใหม่',
    history_all_tab:         'ประวัติ/ทั้งหมด',
    active_total:            'ยอดแอคทีฟทั้งหมด',
    this_month:              'เดือนนี้',
    all_members:             'สมาชิกทั้งหมด',
    total_referred:          'แนะนำสมาชิกทั้งหมด',
    deposited_badge:         'เติมเงินแล้ว',
    not_deposited_badge:     'ยังไม่เติม',
    income_summary_all:      'สรุปรายได้ ทั้งหมด',
    network_income_total:    'รายได้จากเครือข่าย ทั้งหมด',
    income_this_month:       'รายได้เดือนนี้',
    income_last_month:       'รายได้เดือนที่แล้ว',
    aff_easy_rich_tagline:   'รวยง่ายๆ กับ Salmon',
    aff_share_link_tagline:  'แค่แชร์ลิงก์ก็สร้างรายได้',
    aff_step1:               'คัดลอกลิงก์แนะนำเพื่อน',
    aff_step2:               'แชร์ให้เพื่อนผ่านไลน์หรือโซเชียลมีเดีย',
    aff_step3:               'เพื่อนสมัครสมาชิกและเติมเงิน',
    aff_step4:               'รับรายได้อัตโนมัติทันที',
    your_link:               'ลิงก์ของคุณ',
    aff_tab_overview:        'ภาพรวม',
    aff_tab_members:         'สมาชิก',
    aff_tab_income:          'สรุปรายได้',
    aff_tab_network:         'เครือข่าย',
    aff_claim_success:       'ทำรายการรับเงินเรียบร้อย',
    aff_no_balance:          'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
    aff_claim_failed:        'ไม่สามารถทำรายการได้',
    user_label:              'ยูสเซอร์',

    footer_site_heading:     'เว็บที่ให้บริการคาสิโนออนไลน์เต็มรูปแบบ ทั้งสล็อตออนไลน์ คาสิโนสด บาคาร่าสด เกมแทงปลา เกมกีฬา ฯลฯ',
    footer_p1:               'โดยผู้เล่นสามารถสนุกกับเกมของเราได้ด้วยเงินเดิมพันขั้นต่ำเพียง 10 บาทเท่านั้น และสามารถทำการฝาก-ถอนได้ตลอด 24 ชั่วโมง ด้วยระบบออโต้ ทั้งสะดวก รวดเร็วทันใจ เหมาะสำหรับผู้ที่ชื่นชอบการเดิมพันออนไลน์อันดับ 1',
    footer_service_heading:  'บริการประทับใจ ก็ไม่เป็นสองรองใคร ใส่ใจทุกคำตอบ ตลอด 24 ชั่วโมง 7 วันต่อสัปดาห์ไม่มีหยุด',
    footer_p2_part1:         'เพราะผู้เล่นทุกท่าน คือ คนสำคัญของเรา และเรายังมีทีมลูกค้าสัมพันธ์ที่คอยให้ความช่วยเหลือ ตอบทุกคำถาม ให้บริการทุกเรื่องที่คุณสงสัยตลอด 24 ชั่วโมง เพื่อให้คนสำคัญของเราไม่ต้องกังวลกับปัญหาที่พบตั้งแต่ต้นจนจบ นอกจากนี้ เรายังมีเว็บคาสิโน และสล็อตพันธมิตรชั้นนำที่พร้อมมาเสิร์ฟความหลากหลายของเกม และความสนุกสนาน ให้คุณได้เพลิดเพลิน เช่น SA Gaming,',
    footer_p2_part2:         'Gaming, WM Casino, Dream Gaming, Pretty Gaming, ALLBET, Joker, PG Slot และอื่นๆ อีกมากมายจนผู้เล่นจะติดใจอย่างแน่นอน',
    footer_p3:               'ผู้ริเริ่มและผู้ให้บริการเกมคาสิโนชั้นนำรวบรวมเอาไว้อย่างครบครัน ตอบโจทย์ได้ดีที่สุด มีเกมให้เลือกหลากหลาย เล่นง่าย ไม่รู้สึกเบื่อ ระบบที่มีความเสถียรภาพ พัฒนาให้มีความทันสมัยอยู่ตลอดเวลา สัมผัสบรรยากาศที่สมจริงถ่ายทอดสดให้ได้ร่วมติดตามผลการเดิมพันอย่างใกล้ชิด ลุ้นสนุกตลอด 24 ชั่วโมง evocasino เปิดประสบการณ์ใหม่ๆ สร้างความตื่นตาตื่นใจได้เป็นอย่างดี',
    footer_casino_online:    'เว็บคาสิโนออนไลน์',
    footer_baccarat_tagline: 'บาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง',

    cancel_promo_confirm:    'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
    action_failed_wait:      'ไม่สามารถดำเนินการได้ โปรดรอซักครู่',
    promo_not_eligible:      'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
    promo_pending_deposit:   'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',

    promo_join_title:        'การเข้าร่วมโปรโมชั่น',
    no_transaction_text:     'คุณยังไม่มีข้อมูลการทำรายการค่ะ',
    status_label:            'สถานะ :',
    status_cancel_player:    'ยกเลิก (ยกเลิกโดยผู้เล่น)',
    status_cancel_player_short: 'ยกเลิก (โดยผู้เล่น)',
    status_failed_system:    'ไม่สำเร็จ (โดยระบบ)',
    time_unit:               'น.',

    login_redirecting:       'เข้าสู่ระบบ กำลังเปลี่ยนเส้นทาง',
    invalid_credentials:     'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
    contact_problem_title:   'พบปัญหา',
    contact_support_text:    'ติดต่อฝ่ายบริการลูกค้า',
    phone_invalid:           'คุณใส่เบอร์ผิดพลาด',
    phone_in_use:            'เบอร์นี้มีคนใช้แล้ว',
    rate_limited:            'คุณทำรายการถี่เกินไป โปรดรอซักครู่',
    fill_bank_info:          'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน',
    incomplete_digits:       'คุณใส่ตัวเลขไม่ครบ',
    otp_invalid:             'รหัสผิดพลาด',
    no_account_number:       'คุณไม่ทำการใส่เลขบัญชีธนาคาร',
    no_bank_selected:        'คุณยังไม่ได้เลือกธนาคาร',
    invalid_account_number:  'เลขบัญชีไม่ถูกต้อง',
    register_success:        'ทำการสมัครเรียบร้อย กรุณารอซักครู่',
    account_already_registered: 'เลขบัญชี นี้ทำการสมัครไปแล้ว',
    username_already_taken:  'Username นี้ทำการสมัครไปแล้ว',
    invalid_username_name:   'Username หรือ ชื่อในการสมัครไม่ถูกต้อง',
    no_fullname:             'คุณไม่ทำการใส่ ชื่อ-นามสกุล',
    password_max_15:         'พาสเวิดสูงสุดไม่เกิน 15 ตัว',
    password_min_4:          'พาสเวิดต่ำสุดไม่เกิน 4 ตัว',
    confirm_password_mismatch: 'รหัสยืนยันไม่ตรงกัน',

    rank_claim_confirm:      'คุณต้องการเคลม Rank หรือ ไม่?',
    current_deposit:         'ยอดฝากปัจจุบัน',
    need_deposit:            'คุณต้องทำยอดฝาก',
    not_qualified:           'ยังไม่ผ่านเงื่อนไข',
    processing_label:        'กำลังดำเนินการ...',
    deposit_baht_up:         'บาทขึ้นไป',
    deposit_limit_prefix:    'เติมขั้นต่ำ',

    loss_calculated_title:   'ยอดเสียที่คำนวณได้',
    daily_type:              'รายวัน',
    weekly_type:             'รายอาทิตย์',
    monthly_type:            'รายเดือน',
    next_round_prefix:       'รอบถัดไป:',
    total_receivable_cashback: 'ยอดคืนเงินที่รับได้ทั้งหมด',
    withdrawable_cashback:   'ยอดคืนที่ถอนได้',

    coming_soon:             'เร็วๆ นี้',
    toprank_subtitle:        'อัปเดตล่าสุด · ยอดชนะสูงสุด',

    checkin_success_title:   'เช็คอินสำเร็จ',
    checkin_failed_title:    'เช็คอินไม่สำเร็จ',
    checkin_error_title:     'ไม่สามารถเช็คอินได้',
    checkin_date_wrong:      'วันที่เช็คอินไม่ตรงกับวันนี้',
    claim_reward_success:    'รับรางวัลสะสมสำเร็จ',
    claim_reward_failed:     'รับรางวัลไม่สำเร็จ',
    checkin_error_msg:       'เกิดข้อผิดพลาดในการเช็คอิน',
    try_again:               'กรุณาลองใหม่อีกครั้ง',

    login_first_title:       'กรุณาเข้าสู่ระบบ',
    login_first_text:        'คุณต้องเข้าสู่ระบบก่อนแลกของรางวัล',
    not_enough_points_title: 'พ้อยต์ไม่เพียงพอ',
    redeem_success_title:    'แลกสำเร็จ!',
    redeem_success_text:     'คำขอแลกของรางวัลของคุณถูกบันทึกแล้ว',
    failed_title:            'ไม่สำเร็จ',

    announcement_label:      'ประกาศ',
    hide_today:              'ไม่แสดงอีกวันนี้',

    textslide_default:       'เว็บใหญ่ ไม่ล็อคยูส ฝาก-ถอน โอนไว 10วินาที ไม่มีขั้นต่ำ ไม่มีเทิร์น ไม่จำกัดถอน คืนค่ายอดเสีย 8% ทุกค่าย แนะนำเพื่อน0.8% แอดมินดูแลตลอด24ชม.',

    promo_daily_used_up:     'ท่านใช้สิทธวันนี้ครบแล้ว',
    promo_already_used:      'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว',
    coupon_success_title:    'ดำเนินการใช้คูปองเรียบร้อย',
    invalid_coupon:          'ไม่มี Key นี้ในระบบ',
    no_current_promo:        'ไม่มีโปรโมชั่นที่กำลังใช้งานอยู่',
    cancel_promo_title:      'ยกเลิกโปรโมชั่น?',
    cancel_promo_text:       'คุณต้องการยกเลิกโปรโมชั่นปัจจุบันหรือไม่',
    cancel_promo_success:    'ยกเลิกโปรโมชั่นเรียบร้อย',
    cancel_promo_failed:     'ไม่สามารถยกเลิกโปรโมชั่นได้',
    current_promo_label:     'โปรโมชั่นปัจจุบัน',
    promo_auto_on_deposit:   'โปรโมชั่นจะเข้าอัตโนมัติเมื่อเติมเงิน',
    cancelling_label:        'กำลังยกเลิก...',
    no_promo_selected:       'ไม่มีการรับโปรโมชั่น',
    select_promo_below:      'สามารถเลือกโปรโมชั่นด้านล่างได้เลย',
    terms_conditions:        'ข้อตกลงเเละเงื่อนไข',
    promo_not_active:        'โปรโมชั่นยังไม่ได้เปิดใช้งาน',

    cards_used_today:        'คุณเปิดไพ่ครบแล้วในวันนี้ กรุณารอวันใหม่',
    not_enough_points_game:  'แต้มไม่พอในเล่นเกมนี้',
    login_first_play:        'กรุณาเข้าสู่ระบบก่อนเล่น',
    select_activity_first:   'กรุณาเลือกกิจกรรมก่อนเล่น',
    card_reshuffle_title:    'ทางเราจะ reset ไพ่ให้ใหม่',
    card_reshuffle_text:     'กรุณากดปุ่ม "ตกลง" เพื่อทำการสุ่มใหม่',
    open_card_event_title:   'กิจกรรมเปิดไพ่',
    points_available_label:  'จำนวนแต้มที่ใช้ได้',
    point_unit:              'แต้ม',
    enter_game_btn:          'เข้าเล่น',
    open_card_btn:           'เปิดไพ่',
    card_shuffled_done:      'สุ่มไพ่เรียบร้อย',
    card_event_conditions:   'เงื่อนไขในการร่วมสนุก',
    no_condition_found:      'เงื่อนไขในการเปิด: ไม่พบ',
    can_open_per_day:        'สามารถเปิดได้วันละ 2 ครั้ง เท่านั้น',
    detail_label:            'รายละเอียด :',
    card_history_col:        'ประวัติทำรายการ',
    card_history_title:      'ประวัติการเล่นเปิดไพ่',
    all_records:             'ทั้งหมด',
    no_records_found:        'ไม่พบรายการ...',
    time_col:                'เวลา',
    amount_label_col:        'จำนวนเงิน',

    you_have_label:          'คุณมี',
    needed_label:            'ต้องการ',
    redeem_verb:             'แลก',
    use_verb_label:          'ใช้',
    to_redeem_for_label:     'เพื่อแลก',
    today_text:              'วันนี้',
    this_week_text:          'สัปดาห์นี้',

    cashback_success_notify: 'ทำรายการรับเงินเรียบร้อย',
    cashback_no_balance:     'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
    cashback_failed:         'ไม่สามารถทำรายการได้',
    not_logged_in:           'คุณยังไม่ได้ทำการล๊อคอิน',

    process_success:         'ดำเนินการเรียบร้อย',
    deposit_max_label:       'บาท สูงสุด',
    bonus_label:             'โบนัส',
  },

  en: {
    confirm: 'Confirm', cancel: 'Cancel', save: 'Save', back: 'Back',
    close: 'Close', copy: 'Copy', copied: 'Copied!', loading: 'Loading...',
    error: 'An error occurred', success: 'Success', submit: 'Submit',
    or: 'or', contact: 'Contact', baht: 'THB', ok: 'OK',
    search: 'Search', more: 'View More', no_data: 'No data available',

    home: 'Home', deposit: 'Deposit', withdraw: 'Withdraw', history: 'History',
    promotion: 'Promotions', affiliate: 'Referral', cashback: 'Cashback',
    toprank: 'Rankings', redeem_reward: 'Redeem Rewards', rebate: 'Rebate',
    profile: 'Profile', logout: 'Logout', login: 'Login', register: 'Register',
    lucky_fortune: 'Lucky Wheel', check_in: 'Daily Check-In', event: 'Events',
    casino: 'Casino', slot: 'Slots', fishing: 'Fishing', sport: 'Sports',
    lotto: 'Lottery', card_game: 'Card Games',

    menu_home: 'Home', menu_deposit: 'Deposit', menu_contact: 'Contact',
    menu_promotion: 'Promo', menu_profile: 'Account',

    login_title: 'Login', login_phone: 'Sign in with phone number',
    username_label: 'Phone Number', password_label: 'Password',
    forgot_password: 'Forgot Password', no_account: "Don't have an account?",
    register_now: 'Register Now', login_btn: 'Login',

    register_title: 'Register', firstname: 'Full Name',
    phone_number: 'Phone Number', confirm_password: 'Confirm Password',
    invite_code: 'Invite Code (optional)', have_account: 'Already have an account?',
    login_now: 'Login Now', select_bank: 'Select Bank',
    account_number_label: 'Bank Account Number', register_btn: 'Register',

    deposit_title: 'Deposit', bank_tab: 'Bank Transfer',
    truemoney_tab: 'TrueMoney', payment_tab: 'Payment Gateway',
    upload_slip_tab: 'Upload Slip', account_name: 'Account Name',
    bank_name: 'Bank', min_amount: 'Min', max_amount: 'Max',
    amount_label: 'Amount (THB)', amount_placeholder: 'Enter amount',
    quick_fill: 'Quick Fill', scan_qr: 'Scan QR Code to Pay',
    upload_slip: 'Upload Slip', drag_drop_text: 'Drag & drop or click to select',
    select_file: 'Select File', conditions_title: 'Deposit Conditions',
    confirm_deposit: 'Confirm Deposit', copy_account: 'Copy',
    deposit_to: 'Transfer to', upload_success: 'Upload Successful!',
    upload_success_desc: 'Your slip has been submitted.',
    supported_format: 'JPG, PNG, WEBP up to 5MB', change_slip: 'Change Image',
    create_qr: 'Create QR Code to Pay', confirm_payment: 'Confirm Payment',
    promptpay_only: 'PromptPay / Bank Only', confirm_upload: 'Confirm Upload',
    uploading: 'Uploading...', upload_slip_title: 'Upload Slip',
    upload_slip_desc: 'Attach transfer proof', upload_success_title: 'Slip Uploaded',
    processing: 'Processing, please wait', reupload: 'Upload Again',
    upload_conditions_title: 'Slip Upload Conditions',
    tap_select_image: 'Tap to select slip image', go_promotion: 'View Promotions',

    crypto_tab: 'Crypto', crypto_currency: 'Currency', crypto_network: 'Network',
    crypto_address: 'Wallet Address', crypto_scan_qr: 'Scan QR to Transfer',
    crypto_copy: 'Copy Address', crypto_upload_slip: 'Attach Transfer Proof',
    crypto_note: 'Warning: Transfer to the correct currency & network, or funds may be lost.',
    crypto_rate_note: 'Exchange rate is referenced at the time of transaction.',
    crypto_confirm: 'Confirm Transfer',

    withdraw_title: 'Withdraw', withdraw_amount: 'Withdrawal Amount', select_amount: 'Select Amount',
    withdraw_to: 'Withdraw to Account', withdraw_min: 'Min Withdrawal',
    withdraw_max: 'Max Withdrawal', available_balance: 'Available Balance',
    confirm_withdraw: 'Confirm Withdrawal',

    profile_title: 'Profile', account_info: 'Account Info', fullname: 'Full Name',
    rank: 'Rank', credit: 'Credits', point: 'Points',
    change_password: 'Change Password', old_password: 'Current Password',
    new_password: 'New Password', account_number: 'Account Number',

    history_title: 'Transaction History', all_type: 'All',
    deposit_type: 'Deposit', withdraw_type: 'Withdraw', bonus_type: 'Bonus',
    date_col: 'Date', amount_col: 'Amount', status_col: 'Status',
    status_approve: 'Approved', status_pending: 'Pending', status_reject: 'Rejected',

    promotion_title: 'Promotions', apply_promo: 'Apply',
    in_use_promo: 'In Use', promo_full: 'Full', promo_available: 'Available',
    promo_detail: 'Details', no_promotion: 'No promotions available',
    cancel_promo: 'Cancel Promotion', min_deposit: 'Min Deposit',
    bonus_percent: 'Bonus', max_withdraw: 'Max Withdraw', turn_over: 'Turnover',

    affiliate_title: 'Referral Program', invite_link: 'Referral Link',
    today_income: "Today's Income", total_income: 'Total Income',
    member_count: 'Members', withdraw_btn: 'Withdraw', share_line: 'Share LINE',

    cashback_title: 'Cashback', period_label: 'Period',
    eligible_amount: 'Eligible Loss', cashback_rate: 'Rate',
    receive_cashback: 'Claim Cashback', cashback_history: 'Claim History',

    rebate_title: 'Rebate', rebate_amount: 'Bet Amount', receive_rebate: 'Receive',

    toprank_title: 'Rankings', rank_col: 'Rank',
    username_col: 'Username', credit_col: 'Credits',

    redeem_title: 'Redeem Rewards', redeem_btn: 'Redeem',
    my_points: 'My Points', required_points: 'Points Required',

    spin_btn: 'Spin', spin_free: 'Free', spin_remaining: 'Remaining',
    checkin_day: 'Day', checkin_title: 'Daily Check-In',
    checkin_btn: 'Check In', checkin_done: 'Checked In',

    language_label: 'Language', footer_seo_title: 'Full-Featured Online Casino',
    footer_desc: 'Auto deposit & withdrawal 24 hours a day',

    event_title: 'Events',

    register_phone_subtitle: 'Register with phone number',
    referrer:                'Referrer',
    next:                    'Next',
    password_step:           'Password',
    select_bank_title:       'Please select your bank',
    account_no_placeholder:  'Account Number',
    account_name_placeholder:'Account Name',
    contact_btn:             'Contact',

    checkin_activity_title:        'Check-In Activity',
    checkin_subtitle:              'Receive rewards daily by checking in and accumulate for higher prizes',
    checkin_min_deposit_prefix:    'Deposit',
    checkin_min_deposit_suffix:    'or more',
    today:                         'Today',
    checkin_monthly:               'Monthly Check-In',
    max_label:                     'Max',
    day_unit:                      'Days',

    my_points_label:    'Your Points',
    reward_items_tab:   'Rewards',
    redeem_history_tab: 'Redemption History',
    no_rewards_yet:     'No rewards available yet',
    no_redeem_history:  'No redemption history yet',
    stock_remaining:    'Remaining',
    out_of_stock:       'Out of Stock',
    redeem_now:         'Redeem Now',
    not_enough_points:  'Insufficient Points',

    lucky_wheel_title: 'Lucky Wheel',
    spin_wheel_btn:    'Spin the Wheel',
    lucky_wheel_alt:           'Lucky Wheel',
    invite_success:            'Claim processed successfully.',
    invite_no_balance:         'Cannot process — no balance available.',
    action_failed:             'Unable to process this transaction.',
    wheel_conditions_title:    'Terms of Service',
    wheel_cond_deposit:        '• Deposit 1,000 THB cumulative to receive 1 ticket (max 5 tickets/day)',
    wheel_cond_reset_prefix:   '• Cumulative deposit will be',
    wheel_cond_reset_value:    'reset to 0',
    wheel_cond_reset_suffix:   'at 00:00 every day.',
    wheel_cond_ticket_note:    '*Wheel tickets are calculated only when you visit this page.',
    wheel_cond_no_entry:       'If you do not visit, you will not receive tickets.',

    popular:          'Popular',
    esport:           'E-Sports',
    slots_popular:    'Popular Slots',
    casino_popular:   'Popular Online Casino',
    lucky_wheel_short:'Wheel',
    open_card:        'Card Game',
    open_card_event:  'Card Game Event',
    checkin_short:    'Check-In',
    loss_cashback:    'Cashback',
    loss_short:       'Loss',
    deposit_problem:  'If you have a deposit issue or other problems, please contact staff.',

    trading:          'Trading',
    play_btn:         'Play',
    not_open_yet:     'Not Open',
    play_game:        'Play',

    your_account:       'Your Account',
    transfer_note_only: 'Please transfer only via the account provided by the system.',
    bank_dest:          'Destination Bank',
    savings_type:       'Savings',
    acc_no_label:       'Account No.',
    copy_acc_no:        'Copy Account No.',
    notify_transfer_done: 'Transfer Notified',
    notify_transfer:    'Notify Transfer',
    transfer_warning:   'Please notify within 5 minutes after transferring.',
    uploading_slip:     'Uploading slip...',
    confirm_upload_btn: 'Confirm Upload',
    payment_channel:    'Payment Channel',
    wallet_type:        'Wallet',
    wallet_number_label:'Wallet Number',
    copy_wallet_no:     'Copy Wallet No.',
    truemoney_warning:  'Transfer from TrueMoney app to the number above, then notify via LINE Admin. Credits will be added within 5 minutes.',

    cond_pay_1: 'Please confirm and pay within the specified time.',
    cond_pay_2: 'If credits are not received after payment, please contact admin.',
    cond_pay_3: 'Do not press the confirm button multiple times unnecessarily.',
    cond_slip_1:'Upload the slip only after completing the transfer.',
    cond_slip_2:'The image must be clear, showing the amount and transfer time.',
    cond_slip_3:'Do not upload duplicate or fake slips.',

    qr_for_payment:      'QR Code for Payment',
    scan_once_only:      'QR Code can be scanned for payment once only. Do not scan again.',
    pay_within_time:     'Please complete payment within the specified time.',
    cancel_transaction:  'Cancel Transaction',
    new_transaction:     'New Transaction',
    payment_via_system:  'Pay via Payment Gateway',
    min_deposit_note:    'Min deposit {min} THB, Max {max} THB',
    cond_slip_4:         'Credits will be added within 5 minutes after verification.',
    cond_slip_5:         'If there are issues, contact admin via Line.',
    confirm_transfer:    'Confirm Transfer',
    crypto_warning_net:  'Transfer to the exact currency and network shown. Otherwise funds are lost and unrecoverable.',
    exchange_rate_note:  'Exchange rate is referenced at the time of transaction.',
    game_balance:        'In-Game Balance',
    mission_label:       'Missions',
    sec_unit:            'seconds',
    notify_slip_warning: 'Please notify within 5 minutes after transfer. The system will auto-cancel if exceeded.',

    crypto_title_short:  'Crypto',
    crypto_send_note:    'Transfer crypto to the wallet address below',
    select_currency:     'Select Currency',
    wallet_address_label:'Wallet Address',
    min_label_short:     'Min',
    max_label_short:     'Max',
    attach_proof:        'Attach Transfer Proof',
    drag_or_click:       'Drag & drop or click to select',
    click_to_change:     'Click to change image',

    not_logged_in:           'Not logged in',
    not_logged_in_text:      'You are not logged in',
    select_slip_file:        'Please select a slip file',
    upload_slip_failed:      'Slip upload failed',
    transaction_done:        'Transaction completed',
    transaction_failed:      'Transaction failed',
    error_occurred:          'An error occurred',
    session_expired:         'Session expired. Please log in again.',
    game_problem:            'Game is currently unavailable. Please wait.',
    qr_scan_5min:            'Please scan QR Code within 5 minutes',
    force_withdraw_all:      'Full balance withdrawal required',
    insufficient_withdraw:   'Insufficient balance for withdrawal',
    withdraw_success:        'Withdrawal submitted',
    turnover_remaining_prefix: 'Turnover remaining',
    min_withdraw_prefix:     'Minimum withdrawal',
    withdraw_error:          'Withdrawal failed. Please contact staff.',
    withdraw_problem:        'Withdrawal issue. Please contact staff.',
    change_password_success: 'Password changed successfully',
    wrong_old_password:      'Current password is incorrect',
    password_error:          'An error occurred. Please try again.',
    same_password:           'New password must differ from old password',
    password_mismatch:       'Passwords do not match',
    copy_success:            'Copied!',
    select_file_first:       'Please select a file before confirming',
    time_expired:            'Expired',
    hour_unit:               'hours',

    truegift_tab:            'True Gift Voucher',
    no_bank_account:         'No bank account found',
    copy_acc_done:           'Account number copied!',
    copy_acc_prefix:         'Copy Account',
    select_deposit_amount:   'Select deposit amount',
    enter_amount:            'Enter amount',
    bank_transfer_warning:   'Transfer only from your registered account. Transfers from other accounts will not be auto-detected. Please notify via LINE Admin.',
    no_autoslip:             'No AutoSlip account found',
    upload_slip_auto_label:  'Upload Slip (Auto-verify)',
    confirm_upload_slip:     'Confirm Slip Upload',
    upload_success_checking: 'Uploaded! System is verifying...',
    transfer_warning_short:  'Transfer only from your registered account',
    no_truewallet:           'No TrueMoney wallet found',
    truemoney_phone_label:   'Your TrueMoney Phone Number',
    submitting:              'Submitting...',
    notify_truemoney_deposit:'Notify TrueMoney Deposit',
    truemoney_submit_success:'TrueMoney deposit submitted. Please wait for verification.',
    deposit_gift_truemoney:  'Deposit with Gift TrueMoney',
    gift_paste_hint:         'Paste gift link from gift.truemoney.com and submit',
    gift_link_label:         'Gift TrueMoney Link',
    checking:                'Checking...',
    send_gift_link:          'Send Gift Link',
    gift_submit_success:     'Gift link submitted. Please wait for verification.',
    no_payment_gateway:      'No Payment Gateway found',
    pay_via_gateway:         'Pay via Payment Gateway',
    contact_admin:           'Please contact Admin',
    no_crypto:               'No crypto wallet found',
    crypto_thb_label:        'Enter amount (THB) to transfer',
    crypto_amount_prefix:    'Amount of',
    crypto_amount_suffix:    'to transfer',
    crypto_send_only:        'Please send only',
    crypto_send_only_suffix: 'only',
    crypto_wrong_type_warning:'Sending wrong currency type may result in loss of funds.',
    load_failed_retry:       'Failed to load data. Please try again.',

    from_last_month:         'vs last month',
    withdrawable_income:     'Withdrawable Income',
    members_this_month:      'Members This Month',
    new_members_today:       'New Members Today',
    person_unit:             'people',
    how_to_build_network:    'How to Build Your Network',
    seven_days_filter:       '7 Days',
    month_filter:            'Month',
    new_member_tab:          'New Members',
    history_all_tab:         'History / All',
    active_total:            'Total Active',
    this_month:              'This Month',
    all_members:             'All Members',
    total_referred:          'Total Referrals',
    deposited_badge:         'Deposited',
    not_deposited_badge:     'Not Deposited',
    income_summary_all:      'Income Summary - All',
    network_income_total:    'Total Network Income',
    income_this_month:       'Income This Month',
    income_last_month:       'Income Last Month',
    aff_easy_rich_tagline:   'Get Rich Easily with Salmon',
    aff_share_link_tagline:  'Just share your link to earn income',
    aff_step1:               'Copy your referral link',
    aff_step2:               'Share with friends via LINE or social media',
    aff_step3:               'Friend registers and deposits',
    aff_step4:               'Receive income automatically',
    your_link:               'Your Link',
    aff_tab_overview:        'Overview',
    aff_tab_members:         'Members',
    aff_tab_income:          'Income',
    aff_tab_network:         'Network',
    aff_claim_success:       'Income claimed successfully',
    aff_no_balance:          'Cannot process — no balance available',
    aff_claim_failed:        'Cannot process the request',
    user_label:              'User',

    footer_site_heading:     'A full-featured online casino — slots, live casino, live baccarat, fish shooting, sports, and more.',
    footer_p1:               'Players can enjoy our games with a minimum bet of just 10 THB and deposit-withdraw 24 hours a day via auto system. Fast, convenient, and perfect for online gaming enthusiasts. Ranked #1.',
    footer_service_heading:  'Impressive service, second to none. Attentive to every question, 24 hours a day, 7 days a week, no days off.',
    footer_p2_part1:         'Every player matters to us. Our customer relations team is ready to help, answer every question, and assist with any inquiry 24/7 so our valued members never need to worry. We also have leading casino and slot partners bringing diverse games and entertainment, including SA Gaming,',
    footer_p2_part2:         'Gaming, WM Casino, Dream Gaming, Pretty Gaming, ALLBET, Joker, PG Slot and many more that will surely keep you coming back.',
    footer_p3:               'A pioneering and leading casino game provider with a comprehensive collection. Wide game selection, easy to play, never boring. Stable and modern system. Experience realistic live broadcasts, follow betting results closely, and enjoy excitement 24 hours a day. evocasino opens up new experiences and truly impresses.',
    footer_casino_online:    'Online Casino',
    footer_baccarat_tagline: 'Baccarat Online Casino — the best for a truly great player experience.',

    cancel_promo_confirm:    'Do you want to cancel this promotion?',
    action_failed_wait:      'Unable to process. Please wait a moment.',
    promo_not_eligible:      'You do not meet the conditions for this promotion.',
    promo_pending_deposit:   'You have a pending promotion. You may deposit now.',

    promo_join_title:        'Promotion Participation',
    no_transaction_text:     'You have no transaction records yet.',
    status_label:            'Status:',
    status_cancel_player:    'Cancelled (by player)',
    status_cancel_player_short: 'Cancelled (player)',
    status_failed_system:    'Failed (system)',
    time_unit:               '',

    login_redirecting:       'Logged in. Redirecting...',
    invalid_credentials:     'Username or password is incorrect.',
    contact_problem_title:   'Problem Found',
    contact_support_text:    'Contact Customer Service',
    phone_invalid:           'Invalid phone number.',
    phone_in_use:            'This phone number is already in use.',
    rate_limited:            'Too many requests. Please wait a moment.',
    fill_bank_info:          'Please select a bank or fill in all information.',
    incomplete_digits:       'Incomplete number entered.',
    otp_invalid:             'Invalid code.',
    no_account_number:       'Please enter your bank account number.',
    no_bank_selected:        'Please select a bank.',
    invalid_account_number:  'Invalid account number.',
    register_success:        'Registration successful. Please wait.',
    account_already_registered: 'This account number is already registered.',
    username_already_taken:  'This username is already taken.',
    invalid_username_name:   'Invalid username or name.',
    no_fullname:             'Please enter your full name.',
    password_max_15:         'Password must not exceed 15 characters.',
    password_min_4:          'Password must be at least 4 characters.',
    confirm_password_mismatch: 'Confirmation code does not match.',

    rank_claim_confirm:      'Do you want to claim Rank?',
    current_deposit:         'Current Deposit',
    need_deposit:            'You need to deposit',
    not_qualified:           'Condition not met',
    processing_label:        'Processing...',
    deposit_baht_up:         'THB or more',
    deposit_limit_prefix:    'Min deposit',

    loss_calculated_title:   'Calculated Loss',
    daily_type:              'Daily',
    weekly_type:             'Weekly',
    monthly_type:            'Monthly',
    next_round_prefix:       'Next round:',
    total_receivable_cashback: 'Total Receivable Cashback',
    withdrawable_cashback:   'Withdrawable Cashback',

    coming_soon:             'Coming Soon',
    toprank_subtitle:        'Latest update · Highest wins',

    checkin_success_title:   'Check-In Successful',
    checkin_failed_title:    'Check-In Failed',
    checkin_error_title:     'Cannot Check In',
    checkin_date_wrong:      'Check-in date does not match today.',
    claim_reward_success:    'Accumulated reward claimed!',
    claim_reward_failed:     'Failed to claim reward',
    checkin_error_msg:       'An error occurred during check-in.',
    try_again:               'Please try again.',

    login_first_title:       'Please Log In',
    login_first_text:        'You must log in before redeeming rewards.',
    not_enough_points_title: 'Insufficient Points',
    redeem_success_title:    'Redeemed!',
    redeem_success_text:     'Your redemption request has been recorded.',
    failed_title:            'Failed',

    announcement_label:      'Announcement',
    hide_today:              "Don't show again today",

    textslide_default:       'Big site. No user lock. Deposit-withdraw in 10s. No minimum. No turnover. Unlimited withdrawal. 8% cashback on all providers. 0.8% referral. Admin support 24hr.',

    promo_daily_used_up:     "You have used all of today's promotions.",
    promo_already_used:      'You have already used this promotion.',
    coupon_success_title:    'Coupon applied successfully',
    invalid_coupon:          'This key does not exist in the system.',
    no_current_promo:        'No promotion currently active.',
    cancel_promo_title:      'Cancel Promotion?',
    cancel_promo_text:       'Do you want to cancel the current promotion?',
    cancel_promo_success:    'Promotion cancelled successfully.',
    cancel_promo_failed:     'Unable to cancel promotion.',
    current_promo_label:     'Current Promotion',
    promo_auto_on_deposit:   'Promotion will be applied automatically when you deposit.',
    cancelling_label:        'Cancelling...',
    no_promo_selected:       'No promotion selected.',
    select_promo_below:      'You can select a promotion below.',
    terms_conditions:        'Terms & Conditions',
    promo_not_active:        'This promotion is not yet active.',

    cards_used_today:        'You have used all card opens for today. Please wait until tomorrow.',
    not_enough_points_game:  'Not enough points to play this game.',
    login_first_play:        'Please log in before playing.',
    select_activity_first:   'Please select an activity before playing.',
    card_reshuffle_title:    'We will reset the cards for you.',
    card_reshuffle_text:     'Press "OK" to reshuffle.',
    open_card_event_title:   'Card Opening Event',
    points_available_label:  'Available Points',
    point_unit:              'pts',
    enter_game_btn:          'Play',
    open_card_btn:           'Open Card',
    card_shuffled_done:      'Cards shuffled!',
    card_event_conditions:   'Participation Conditions',
    no_condition_found:      'Opening condition: Not found',
    can_open_per_day:        'Can open 2 times per day only.',
    detail_label:            'Details:',
    card_history_col:        'History',
    card_history_title:      'Card Game History',
    all_records:             'All',
    no_records_found:        'No records found...',
    time_col:                'Time',
    amount_label_col:        'Amount',

    you_have_label:          'You have',
    needed_label:            'Need',
    redeem_verb:             'Redeem',
    use_verb_label:          'Use',
    to_redeem_for_label:     'to redeem',
    today_text:              'Today',
    this_week_text:          'This week',

    cashback_success_notify: 'Transaction received successfully.',
    cashback_no_balance:     'Cannot process — no balance.',
    cashback_failed:         'Cannot process transaction.',
    not_logged_in:           'You are not logged in.',

    process_success:         'Processed successfully',
    deposit_max_label:       'THB max',
    bonus_label:             'Bonus',
  },

  zh: {
    confirm: '确认', cancel: '取消', save: '保存', back: '返回',
    close: '关闭', copy: '复制', copied: '已复制！', loading: '加载中...',
    error: '发生错误', success: '成功', submit: '提交',
    or: '或', contact: '联系', baht: '泰铢', ok: '确定',
    search: '搜索', more: '查看更多', no_data: '暂无数据',

    home: '首页', deposit: '存款', withdraw: '取款', history: '记录',
    promotion: '优惠活动', affiliate: '推荐好友', cashback: '返现',
    toprank: '排行榜', redeem_reward: '兑换奖励', rebate: '返水',
    profile: '个人信息', logout: '退出登录', login: '登录', register: '注册',
    lucky_fortune: '幸运转盘', check_in: '每日签到', event: '活动',
    casino: '真人娱乐', slot: '老虎机', fishing: '捕鱼',
    sport: '体育', lotto: '彩票', card_game: '棋牌游戏',

    menu_home: '首页', menu_deposit: '存款', menu_contact: '联系',
    menu_promotion: '优惠', menu_profile: '账户',

    login_title: '登录', login_phone: '使用手机号登录',
    username_label: '手机号码', password_label: '密码',
    forgot_password: '忘记密码', no_account: '还没有账号？',
    register_now: '立即注册', login_btn: '登录',

    register_title: '注册', firstname: '姓名',
    phone_number: '手机号码', confirm_password: '确认密码',
    invite_code: '邀请码（可选）', have_account: '已有账号？',
    login_now: '立即登录', select_bank: '选择银行',
    account_number_label: '银行账号', register_btn: '注册',

    deposit_title: '存款', bank_tab: '银行转账',
    truemoney_tab: '真钱钱包', payment_tab: '支付网关',
    upload_slip_tab: '上传凭证', account_name: '账户名称',
    bank_name: '银行', min_amount: '最低', max_amount: '最高',
    amount_label: '金额（泰铢）', amount_placeholder: '请输入金额',
    quick_fill: '快速填写', scan_qr: '扫码支付',
    upload_slip: '上传凭证', drag_drop_text: '拖放或点击选择文件',
    select_file: '选择文件', conditions_title: '存款条款',
    confirm_deposit: '确认存款', copy_account: '复制',
    deposit_to: '转账至', upload_success: '上传成功！',
    upload_success_desc: '您的凭证已成功提交。',
    supported_format: '支持 JPG、PNG、WEBP，最大 5MB', change_slip: '更换图片',
    create_qr: '生成二维码付款', confirm_payment: '确认付款',
    promptpay_only: '仅限PromptPay / 银行', confirm_upload: '确认上传',
    uploading: '上传中...', upload_slip_title: '上传凭证',
    upload_slip_desc: '上传转账凭证', upload_success_title: '凭证已上传',
    processing: '处理中，请稍候', reupload: '重新上传',
    upload_conditions_title: '上传凭证须知',
    tap_select_image: '点击选择凭证图片', go_promotion: '查看优惠',

    crypto_tab: '加密货币', crypto_currency: '币种', crypto_network: '网络',
    crypto_address: '钱包地址', crypto_scan_qr: '扫码转账',
    crypto_copy: '复制地址', crypto_upload_slip: '上传转账凭证',
    crypto_note: '警告：请转账到正确的币种和网络，否则资金将丢失。',
    crypto_rate_note: '汇率以交易时为准。',
    crypto_confirm: '确认转账',

    withdraw_title: '取款', withdraw_amount: '取款金额', select_amount: '选择金额',
    withdraw_to: '提款至账户', withdraw_min: '最低取款',
    withdraw_max: '最高取款', available_balance: '可用余额',
    confirm_withdraw: '确认取款',

    profile_title: '个人信息', account_info: '账户信息', fullname: '姓名',
    rank: '等级', credit: '余额', point: '积分',
    change_password: '修改密码', old_password: '旧密码',
    new_password: '新密码', account_number: '银行账号',

    history_title: '交易记录', all_type: '全部',
    deposit_type: '存款', withdraw_type: '取款', bonus_type: '奖金',
    date_col: '日期', amount_col: '金额', status_col: '状态',
    status_approve: '成功', status_pending: '待处理', status_reject: '已拒绝',

    promotion_title: '优惠活动', apply_promo: '领取',
    in_use_promo: '使用中', promo_full: '已满', promo_available: '可用',
    promo_detail: '详情', no_promotion: '暂无可用优惠',
    cancel_promo: '取消优惠', min_deposit: '最低存款',
    bonus_percent: '奖金', max_withdraw: '最高取款', turn_over: '流水要求',

    affiliate_title: '推荐好友', invite_link: '推荐链接',
    today_income: '今日收益', total_income: '总收益',
    member_count: '会员数量', withdraw_btn: '提现', share_line: '分享LINE',

    cashback_title: '返现', period_label: '周期',
    eligible_amount: '可返亏损', cashback_rate: '返还比率',
    receive_cashback: '领取返现', cashback_history: '领取记录',

    rebate_title: '返水', rebate_amount: '投注金额', receive_rebate: '领取',

    toprank_title: '排行榜', rank_col: '排名',
    username_col: '用户名', credit_col: '余额',

    redeem_title: '兑换奖励', redeem_btn: '兑换',
    my_points: '我的积分', required_points: '所需积分',

    spin_btn: '旋转', spin_free: '免费', spin_remaining: '剩余次数',
    checkin_day: '天', checkin_title: '每日签到',
    checkin_btn: '签到', checkin_done: '已签到',

    language_label: '语言', footer_seo_title: '全功能在线赌场',
    footer_desc: '全天24小时自动存取款服务',

    event_title: '活动',

    register_phone_subtitle: '使用手机号注册',
    referrer:                '推荐人',
    next:                    '下一步',
    password_step:           '密码',
    select_bank_title:       '请选择银行',
    account_no_placeholder:  '银行账号',
    account_name_placeholder:'账户名称',
    contact_btn:             '联系',

    checkin_activity_title:        '签到活动',
    checkin_subtitle:              '每天登录签到即可领取奖励，累积更多奖励',
    checkin_min_deposit_prefix:    '充值',
    checkin_min_deposit_suffix:    '以上',
    today:                         '今天',
    checkin_monthly:               '本月累积签到',
    max_label:                     '最高',
    day_unit:                      '天',

    my_points_label:    '我的积分',
    reward_items_tab:   '奖品',
    redeem_history_tab: '兑换记录',
    no_rewards_yet:     '暂无奖品',
    no_redeem_history:  '暂无兑换记录',
    stock_remaining:    '剩余',
    out_of_stock:       '已售完',
    redeem_now:         '立即兑换',
    not_enough_points:  '积分不足',

    lucky_wheel_title: '幸运转盘',
    spin_wheel_btn:    '旋转转盘',
    lucky_wheel_alt:           '幸运转盘',
    invite_success:            '成功领取奖励。',
    invite_no_balance:         '无法处理 — 余额不足。',
    action_failed:             '无法完成此交易。',
    wheel_conditions_title:    '服务条款',
    wheel_cond_deposit:        '• 累计存款满1,000泰铢获得1张票（每天最多5张）',
    wheel_cond_reset_prefix:   '• 累计存款将',
    wheel_cond_reset_value:    '归零',
    wheel_cond_reset_suffix:   '每天00:00重置。',
    wheel_cond_ticket_note:    '*转盘票仅在您访问此页面时计算。',
    wheel_cond_no_entry:       '若未访问，将不会获得票。',

    qr_for_payment:      '支付二维码',
    scan_once_only:      '二维码只能扫描一次支付，请勿重复扫描。',
    pay_within_time:     '请在规定时间内完成支付。',
    cancel_transaction:  '取消交易',
    new_transaction:     '新交易',
    payment_via_system:  '通过支付系统付款',
    min_deposit_note:    '最低存款 {min} 泰铢，最高 {max} 泰铢',
    cond_slip_4:         '验证后5分钟内添加积分。',
    cond_slip_5:         '如有问题，请通过Line联系管理员。',
    confirm_transfer:    '确认转账',
    crypto_warning_net:  '请转账到显示的正确币种和网络，否则资金将丢失且无法找回。',
    exchange_rate_note:  '汇率以交易时为准。',
    game_balance:        '游戏余额',
    mission_label:       '任务',
    sec_unit:            '秒',
    notify_slip_warning: '请在转账后5分钟内通知。超时系统将自动取消。',

    popular:          '热门',
    esport:           '电子竞技',
    slots_popular:    '热门老虎机',
    casino_popular:   '热门在线赌场',
    lucky_wheel_short:'转盘',
    open_card:        '开牌游戏',
    open_card_event:  '开牌活动',
    checkin_short:    '签到',
    loss_cashback:    '领取返现',
    loss_short:       '亏损',
    deposit_problem:  '如有存款或其他问题，请联系客服。',

    trading:          '交易',
    play_btn:         '进入游戏',
    not_open_yet:     '未开放',
    play_game:        '玩游戏',
    your_account:       '您的账户',
    transfer_note_only: '请仅通过系统指定账户转账。',
    bank_dest:          '目标银行',
    savings_type:       '储蓄',
    acc_no_label:       '账号',
    copy_acc_no:        '复制账号',
    notify_transfer_done: '已通知转账',
    notify_transfer:    '通知转账',
    transfer_warning:   '请在转账后5分钟内通知。',
    uploading_slip:     '正在上传凭证...',
    confirm_upload_btn: '确认上传',
    payment_channel:    '支付渠道',
    wallet_type:        '钱包',
    wallet_number_label:'钱包号码',
    copy_wallet_no:     '复制钱包号',
    truemoney_warning:  '从TrueMoney应用转账到上方号码，然后通过LINE Admin通知。5分钟内充值。',
    cond_pay_1: '请在规定时间内确认并付款。',
    cond_pay_2: '付款后如未收到积分，请联系管理员。',
    cond_pay_3: '请勿重复点击确认按钮。',
    cond_slip_1:'转账完成后再上传凭证。',
    cond_slip_2:'图片必须清晰，显示金额和转账时间。',
    cond_slip_3:'请勿上传重复或虚假凭证。',
    crypto_title_short:  '加密货币',
    crypto_send_note:    '转账至以下钱包地址',
    select_currency:     '选择货币',
    wallet_address_label:'钱包地址',
    min_label_short:     '最低',
    max_label_short:     '最高',
    attach_proof:        '上传转账凭证',
    drag_or_click:       '拖放或点击选择',
    click_to_change:     '点击更换图片',

    not_logged_in:           '尚未登录',
    not_logged_in_text:      '您还未登录',
    select_slip_file:        '请选择转账凭证文件',
    upload_slip_failed:      '上传凭证失败',
    transaction_done:        '操作成功',
    transaction_failed:      '操作失败',
    error_occurred:          '发生错误',
    session_expired:         'Session已过期，请重新登录。',
    game_problem:            '游戏目前不可用，请稍候。',
    qr_scan_5min:            '请在5分钟内扫描QR码',
    force_withdraw_all:      '需全额提款',
    insufficient_withdraw:   '提款余额不足',
    withdraw_success:        '提款申请成功',
    turnover_remaining_prefix: '剩余流水',
    min_withdraw_prefix:     '最低提款金额',
    withdraw_error:          '提款失败，请联系客服。',
    withdraw_problem:        '提款出现问题，请联系客服。',
    change_password_success: '密码修改成功',
    wrong_old_password:      '旧密码不正确',
    password_error:          '发生错误，请重试。',
    same_password:           '新密码不能与旧密码相同',
    password_mismatch:       '两次密码不一致',
    copy_success:            '已复制！',
    select_file_first:       '请先选择文件再确认',
    time_expired:            '已过期',
    hour_unit:               '小时',

    truegift_tab:            '真钱礼品券',
    no_bank_account:         '未找到银行账户',
    copy_acc_done:           '账号已复制！',
    copy_acc_prefix:         '复制账号',
    select_deposit_amount:   '选择存款金额',
    enter_amount:            '请输入金额',
    bank_transfer_warning:   '请仅使用已注册账户转账。其他账户转账无法自动检测，请通过LINE Admin通知。',
    no_autoslip:             '未找到AutoSlip账户',
    upload_slip_auto_label:  '上传凭证（自动验证）',
    confirm_upload_slip:     '确认上传凭证',
    upload_success_checking: '上传成功！系统正在验证...',
    transfer_warning_short:  '请仅使用已注册账户转账',
    no_truewallet:           '未找到TrueMoney账户',
    truemoney_phone_label:   '您的TrueMoney手机号',
    submitting:              '提交中...',
    notify_truemoney_deposit:'通知TrueMoney存款',
    truemoney_submit_success:'TrueMoney存款已提交，请等待审核。',
    deposit_gift_truemoney:  '使用TrueMoney礼品券存款',
    gift_paste_hint:         '粘贴来自gift.truemoney.com的礼品链接并提交',
    gift_link_label:         'TrueMoney礼品链接',
    checking:                '检查中...',
    send_gift_link:          '发送礼品链接',
    gift_submit_success:     '礼品链接已提交，请等待审核。',
    no_payment_gateway:      '未找到支付网关',
    pay_via_gateway:         '通过支付网关付款',
    contact_admin:           '请联系管理员',
    no_crypto:               '未找到加密货币钱包',
    crypto_thb_label:        '输入要转账的金额（泰铢）',
    crypto_amount_prefix:    '数量',
    crypto_amount_suffix:    '需要转账',
    crypto_send_only:        '请仅发送',
    crypto_send_only_suffix: '以外不可',
    crypto_wrong_type_warning:'发送错误的货币类型可能导致资金损失。',
    load_failed_retry:       '无法加载数据，请重试。',

    from_last_month:         '较上月',
    withdrawable_income:     '可提取收益',
    members_this_month:      '本月会员',
    new_members_today:       '今日新会员',
    person_unit:             '人',
    how_to_build_network:    '如何建立网络',
    seven_days_filter:       '7天',
    month_filter:            '月',
    new_member_tab:          '新会员',
    history_all_tab:         '历史/全部',
    active_total:            '总活跃人数',
    this_month:              '本月',
    all_members:             '全部会员',
    total_referred:          '总推荐会员',
    deposited_badge:         '已充值',
    not_deposited_badge:     '未充值',
    income_summary_all:      '收益汇总 - 全部',
    network_income_total:    '网络总收益',
    income_this_month:       '本月收益',
    income_last_month:       '上月收益',
    aff_easy_rich_tagline:   '轻松致富与 Salmon',
    aff_share_link_tagline:  '分享链接即可赚取收益',
    aff_step1:               '复制您的推荐链接',
    aff_step2:               '通过LINE或社交媒体分享给朋友',
    aff_step3:               '朋友注册并充值',
    aff_step4:               '立即自动获得收益',
    your_link:               '您的链接',
    aff_tab_overview:        '概览',
    aff_tab_members:         '会员',
    aff_tab_income:          '收益汇总',
    aff_tab_network:         '网络',
    aff_claim_success:       '收益领取成功',
    aff_no_balance:          '无法处理 — 没有可用余额',
    aff_claim_failed:        '无法处理请求',
    user_label:              '用户',

    footer_site_heading:     '全功能在线赌场——在线老虎机、真人娱乐场、真人百家乐、捕鱼游戏、体育游戏等。',
    footer_p1:               '玩家只需最低10泰铢即可享受我们的游戏，并可全天24小时通过自动系统进行存取款，方便快捷，非常适合在线投注爱好者。',
    footer_service_heading:  '令人印象深刻的服务，无人能及。全天候专注解答，24小时、每周7天从不停歇。',
    footer_p2_part1:         '每位玩家对我们都至关重要。我们的客服团队随时准备提供帮助，解答每一个问题，全天24小时为您服务。我们还与顶级娱乐场和老虎机合作伙伴合作，为您带来多样化的游戏和娱乐，包括SA Gaming,',
    footer_p2_part2:         'Gaming、WM Casino、Dream Gaming、Pretty Gaming、ALLBET、Joker、PG Slot等众多游戏，玩家一定会爱不释手。',
    footer_p3:               '领先的娱乐场游戏先驱和提供商，内容全面，最能满足您的需求。游戏种类多样，简单易玩，永不无聊。系统稳定，持续创新。体验真实直播氛围，近距离跟踪投注结果，全天24小时尽享精彩。evocasino开创全新体验，令人叹为观止。',
    footer_casino_online:    '在线娱乐场',
    footer_baccarat_tagline: '百家乐在线赌场——最佳选择，为玩家提供真正优质的体验。',

    cancel_promo_confirm:    '确认取消此优惠活动吗？',
    action_failed_wait:      '无法处理，请稍候。',
    promo_not_eligible:      '您不符合此优惠活动的条件。',
    promo_pending_deposit:   '您有待使用的优惠，现在可以充值。',

    promo_join_title:        '参与优惠活动',
    no_transaction_text:     '您还没有交易记录。',
    status_label:            '状态：',
    status_cancel_player:    '已取消（玩家取消）',
    status_cancel_player_short: '已取消（玩家）',
    status_failed_system:    '失败（系统）',
    time_unit:               '',

    login_redirecting:       '登录成功，正在跳转...',
    invalid_credentials:     '用户名或密码不正确。',
    contact_problem_title:   '发现问题',
    contact_support_text:    '联系客服',
    phone_invalid:           '手机号码有误。',
    phone_in_use:            '此手机号已被使用。',
    rate_limited:            '请求过于频繁，请稍候。',
    fill_bank_info:          '请选择银行或填写完整信息。',
    incomplete_digits:       '数字未填写完整。',
    otp_invalid:             '验证码错误。',
    no_account_number:       '请输入银行账号。',
    no_bank_selected:        '请选择银行。',
    invalid_account_number:  '账号无效。',
    register_success:        '注册成功，请稍候。',
    account_already_registered: '此账号已被注册。',
    username_already_taken:  '此用户名已被注册。',
    invalid_username_name:   '用户名或姓名无效。',
    no_fullname:             '请输入姓名。',
    password_max_15:         '密码不超过15个字符。',
    password_min_4:          '密码至少需要4个字符。',
    confirm_password_mismatch: '确认码不匹配。',

    rank_claim_confirm:      '您要领取排名奖励吗？',
    current_deposit:         '当前存款',
    need_deposit:            '您需要充值',
    not_qualified:           '未满足条件',
    processing_label:        '处理中...',
    deposit_baht_up:         '泰铢以上',
    deposit_limit_prefix:    '最低充值',

    loss_calculated_title:   '计算亏损',
    daily_type:              '每日',
    weekly_type:             '每周',
    monthly_type:            '每月',
    next_round_prefix:       '下轮：',
    total_receivable_cashback: '可领返现总额',
    withdrawable_cashback:   '可提取返现',

    coming_soon:             '即将推出',
    toprank_subtitle:        '最新更新 · 最高胜率',

    checkin_success_title:   '签到成功',
    checkin_failed_title:    '签到失败',
    checkin_error_title:     '无法签到',
    checkin_date_wrong:      '签到日期与今天不符。',
    claim_reward_success:    '累积奖励领取成功！',
    claim_reward_failed:     '领取奖励失败',
    checkin_error_msg:       '签到时发生错误。',
    try_again:               '请重试。',

    login_first_title:       '请先登录',
    login_first_text:        '兑换奖励前请先登录。',
    not_enough_points_title: '积分不足',
    redeem_success_title:    '兑换成功！',
    redeem_success_text:     '您的兑换申请已提交。',
    failed_title:            '失败',

    announcement_label:      '公告',
    hide_today:              '今天不再显示',

    textslide_default:       '大型平台，无账户锁定，10秒存取款，无最低限额，无流水要求，无限提款，各平台8%返现，0.8%推荐奖励，24小时客服。',

    promo_daily_used_up:     '您今天的优惠次数已用完。',
    promo_already_used:      '您已使用过此优惠活动。',
    coupon_success_title:    '优惠券使用成功',
    invalid_coupon:          '此码不存在。',
    no_current_promo:        '当前没有使用中的优惠活动。',
    cancel_promo_title:      '取消优惠活动？',
    cancel_promo_text:       '您要取消当前优惠活动吗？',
    cancel_promo_success:    '优惠活动已成功取消。',
    cancel_promo_failed:     '无法取消优惠活动。',
    current_promo_label:     '当前优惠活动',
    promo_auto_on_deposit:   '充值时将自动应用优惠活动。',
    cancelling_label:        '取消中...',
    no_promo_selected:       '未选择优惠活动。',
    select_promo_below:      '您可以在下方选择优惠活动。',
    terms_conditions:        '条款与条件',
    promo_not_active:        '此优惠活动尚未启用。',

    cards_used_today:        '您今天的开牌次数已用完，请等到明天。',
    not_enough_points_game:  '积分不足，无法玩此游戏。',
    login_first_play:        '请先登录再游戏。',
    select_activity_first:   '请先选择活动再游戏。',
    card_reshuffle_title:    '我们将为您重置牌。',
    card_reshuffle_text:     '按确定重新洗牌。',
    open_card_event_title:   '开牌活动',
    points_available_label:  '可用积分',
    point_unit:              '积分',
    enter_game_btn:          '进入',
    open_card_btn:           '开牌',
    card_shuffled_done:      '洗牌完成！',
    card_event_conditions:   '参与条件',
    no_condition_found:      '开牌条件：未找到',
    can_open_per_day:        '每天仅可开牌2次。',
    detail_label:            '详情：',
    card_history_col:        '交易记录',
    card_history_title:      '开牌游戏记录',
    all_records:             '全部',
    no_records_found:        '未找到记录...',
    time_col:                '时间',
    amount_label_col:        '金额',

    you_have_label:          '您有',
    needed_label:            '需要',
    redeem_verb:             '兑换',
    use_verb_label:          '使用',
    to_redeem_for_label:     '兑换',
    today_text:              '今天',
    this_week_text:          '本周',

    cashback_success_notify: '交易领取成功。',
    cashback_no_balance:     '无法处理 — 无余额。',
    cashback_failed:         '无法处理交易。',
    not_logged_in:           '您尚未登录。',

    process_success:         '操作成功',
    deposit_max_label:       '泰铢，最高',
    bonus_label:             '奖励',
  },

  ja: {
    confirm: '確認', cancel: 'キャンセル', save: '保存', back: '戻る',
    close: '閉じる', copy: 'コピー', copied: 'コピーしました！', loading: '読み込み中...',
    error: 'エラーが発生しました', success: '成功', submit: '送信',
    or: 'または', contact: 'お問い合わせ', baht: 'バーツ', ok: 'OK',
    search: '検索', more: 'もっと見る', no_data: 'データなし',

    home: 'ホーム', deposit: '入金', withdraw: '出金', history: '履歴',
    promotion: 'プロモーション', affiliate: '友達紹介', cashback: 'キャッシュバック',
    toprank: 'ランキング', redeem_reward: '報酬交換', rebate: 'リベート',
    profile: 'プロフィール', logout: 'ログアウト', login: 'ログイン',
    register: '新規登録', lucky_fortune: 'ラッキーホイール',
    check_in: 'デイリーチェックイン', event: 'イベント',
    casino: 'カジノ', slot: 'スロット', fishing: '釣りゲーム',
    sport: 'スポーツ', lotto: '宝くじ', card_game: 'カードゲーム',

    menu_home: 'ホーム', menu_deposit: '入金', menu_contact: 'お問い合わせ',
    menu_promotion: 'プロモ', menu_profile: 'アカウント',

    login_title: 'ログイン', login_phone: '電話番号でログイン',
    username_label: '電話番号', password_label: 'パスワード',
    forgot_password: 'パスワードを忘れた', no_account: 'アカウントがありませんか？',
    register_now: '今すぐ登録', login_btn: 'ログイン',

    register_title: '新規登録', firstname: '氏名',
    phone_number: '電話番号', confirm_password: 'パスワード確認',
    invite_code: '招待コード（任意）', have_account: 'すでにアカウントをお持ちですか？',
    login_now: '今すぐログイン', select_bank: '銀行を選択',
    account_number_label: '銀行口座番号', register_btn: '登録する',

    deposit_title: '入金', bank_tab: '銀行振込',
    truemoney_tab: 'トゥルーマネー', payment_tab: '決済ゲートウェイ',
    upload_slip_tab: 'スリップ送信', account_name: '口座名義',
    bank_name: '銀行', min_amount: '最低', max_amount: '最高',
    amount_label: '金額（バーツ）', amount_placeholder: '金額を入力',
    quick_fill: 'クイック入力', scan_qr: 'QRコードをスキャン',
    upload_slip: 'スリップをアップロード',
    drag_drop_text: 'ドラッグ＆ドロップまたはクリックしてファイルを選択',
    select_file: 'ファイルを選択', conditions_title: '入金規約',
    confirm_deposit: '入金を確認', copy_account: 'コピー',
    deposit_to: '振込先', upload_success: 'アップロード完了！',
    upload_success_desc: 'スリップが正常に送信されました。',
    supported_format: 'JPG・PNG・WEBP、最大5MB', change_slip: '画像を変更',
    create_qr: 'QRコードを生成', confirm_payment: '支払いを確認',
    promptpay_only: 'プロンプトペイ / 銀行のみ', confirm_upload: 'アップロードを確認',
    uploading: 'アップロード中...', upload_slip_title: 'スリップを送信',
    upload_slip_desc: '入金証明を添付', upload_success_title: 'スリップ送信完了',
    processing: '処理中。しばらくお待ちください', reupload: '再アップロード',
    upload_conditions_title: 'スリップアップロード規約',
    tap_select_image: 'タップして画像を選択', go_promotion: 'プロモーションへ',

    crypto_tab: '暗号通貨', crypto_currency: '通貨', crypto_network: 'ネットワーク',
    crypto_address: 'ウォレットアドレス', crypto_scan_qr: 'QRコードをスキャンして送金',
    crypto_copy: 'アドレスをコピー', crypto_upload_slip: '送金証明を添付',
    crypto_note: '警告：正しい通貨とネットワークに送金してください。誤送金は返金不可です。',
    crypto_rate_note: '為替レートは取引時点のものを参照します。',
    crypto_confirm: '送金を確認',

    withdraw_title: '出金', withdraw_amount: '出金額', select_amount: '金額を選択',
    withdraw_to: '出金先口座', withdraw_min: '最低出金額',
    withdraw_max: '最高出金額', available_balance: '利用可能残高',
    confirm_withdraw: '出金を確認',

    profile_title: 'プロフィール', account_info: 'アカウント情報', fullname: '氏名',
    rank: 'ランク', credit: 'クレジット', point: 'ポイント',
    change_password: 'パスワード変更', old_password: '現在のパスワード',
    new_password: '新しいパスワード', account_number: '口座番号',

    history_title: '取引履歴', all_type: 'すべて',
    deposit_type: '入金', withdraw_type: '出金', bonus_type: 'ボーナス',
    date_col: '日付', amount_col: '金額', status_col: 'ステータス',
    status_approve: '承認済み', status_pending: '保留中', status_reject: '拒否',

    promotion_title: 'プロモーション', apply_promo: '適用',
    in_use_promo: '使用中', promo_full: '満員', promo_available: '利用可',
    promo_detail: '詳細', no_promotion: '利用できるプロモーションはありません',
    cancel_promo: 'プロモーションをキャンセル', min_deposit: '最低入金額',
    bonus_percent: 'ボーナス', max_withdraw: '最高出金額', turn_over: 'ターンオーバー',

    affiliate_title: '友達紹介', invite_link: '紹介リンク',
    today_income: '本日の収益', total_income: '総収益',
    member_count: '会員数', withdraw_btn: '出金', share_line: 'LINEでシェア',

    cashback_title: 'キャッシュバック', period_label: '期間',
    eligible_amount: '対象損失', cashback_rate: '還元率',
    receive_cashback: 'キャッシュバックを受取る', cashback_history: '受取履歴',

    rebate_title: 'リベート', rebate_amount: 'ベット額', receive_rebate: '受取る',

    toprank_title: 'ランキング', rank_col: '順位',
    username_col: 'ユーザー名', credit_col: 'クレジット',

    redeem_title: '報酬交換', redeem_btn: '交換する',
    my_points: 'マイポイント', required_points: '必要ポイント',

    spin_btn: '回す', spin_free: '無料', spin_remaining: '残り回数',
    checkin_day: '日', checkin_title: 'デイリーチェックイン',
    checkin_btn: 'チェックイン', checkin_done: 'チェックイン済み',

    language_label: '言語', footer_seo_title: 'フルオンラインカジノ',
    footer_desc: '24時間自動入出金サービス',

    event_title: 'イベント',

    register_phone_subtitle: '電話番号で登録',
    referrer:                '紹介者',
    next:                    '次へ',
    password_step:           'パスワード',
    select_bank_title:       '銀行を選択してください',
    account_no_placeholder:  '口座番号',
    account_name_placeholder:'口座名義',
    contact_btn:             'お問い合わせ',

    checkin_activity_title:        'チェックインイベント',
    checkin_subtitle:              '毎日チェックインして報酬を受け取り、累積でさらに高い賞を獲得',
    checkin_min_deposit_prefix:    '入金',
    checkin_min_deposit_suffix:    '以上',
    today:                         '今日',
    checkin_monthly:               '今月のチェックイン',
    max_label:                     '最高',
    day_unit:                      '日',

    my_points_label:    '所持ポイント',
    reward_items_tab:   '報酬',
    redeem_history_tab: '交換履歴',
    no_rewards_yet:     '報酬はまだありません',
    no_redeem_history:  '交換履歴がありません',
    stock_remaining:    '残り',
    out_of_stock:       '在庫なし',
    redeem_now:         '今すぐ交換',
    not_enough_points:  'ポイント不足',

    lucky_wheel_title: 'ラッキーホイール',
    spin_wheel_btn:    'ホイールを回す',
    lucky_wheel_alt:           'ラッキーホイール',
    invite_success:            '報酬の受け取りが完了しました。',
    invite_no_balance:         '処理できません — 残高がありません。',
    action_failed:             'この取引を処理できません。',
    wheel_conditions_title:    'サービス規約',
    wheel_cond_deposit:        '• 1,000バーツ累積入金で1チケット獲得（1日最大5枚）',
    wheel_cond_reset_prefix:   '• 累積入金は毎日00:00に',
    wheel_cond_reset_value:    '0にリセット',
    wheel_cond_reset_suffix:   'されます。',
    wheel_cond_ticket_note:    '*ホイールチケットはこのページにアクセスした場合のみ計算されます。',
    wheel_cond_no_entry:       'アクセスしない場合はチケットを受け取れません。',

    qr_for_payment:      '支払い用QRコード',
    scan_once_only:      'QRコードは1回のみスキャンできます。重複スキャン禁止。',
    pay_within_time:     '指定時間内に支払いを完了してください。',
    cancel_transaction:  '取引をキャンセル',
    new_transaction:     '新しい取引',
    payment_via_system:  '決済システムで支払い',
    min_deposit_note:    '最低入金 {min} バーツ、最高 {max} バーツ',
    cond_slip_4:         '確認後5分以内にクレジットが追加されます。',
    cond_slip_5:         '問題がある場合はLineで管理者にお問い合わせください。',
    confirm_transfer:    '送金を確認',
    crypto_warning_net:  '表示された通貨とネットワークに正確に送金してください。誤送金は返金不可です。',
    exchange_rate_note:  '為替レートは取引時点のものです。',
    game_balance:        'ゲーム内残高',
    mission_label:       'ミッション',
    sec_unit:            '秒',
    notify_slip_warning: '送金後5分以内に通知してください。超過した場合は自動キャンセルされます。',

    popular:          '人気',
    esport:           'eスポーツ',
    slots_popular:    '人気スロット',
    casino_popular:   '人気オンラインカジノ',
    lucky_wheel_short:'ホイール',
    open_card:        'カードゲーム',
    open_card_event:  'カードゲームイベント',
    checkin_short:    'チェックイン',
    loss_cashback:    'キャッシュバック受取',
    loss_short:       '損失',
    deposit_problem:  '入金やその他の問題が発生した場合は、スタッフにお問い合わせください。',

    trading:          'トレーディング',
    play_btn:         'プレイ',
    not_open_yet:     '未公開',
    play_game:        'ゲームをプレイ',
    your_account:       'あなたの口座',
    transfer_note_only: 'システムが指定した口座のみへ振り込んでください。',
    bank_dest:          '振込先銀行',
    savings_type:       '普通預金',
    acc_no_label:       '口座番号',
    copy_acc_no:        '口座番号をコピー',
    notify_transfer_done: '振込通知済み',
    notify_transfer:    '振込を通知',
    transfer_warning:   '振込後5分以内に通知してください。',
    uploading_slip:     'スリップアップロード中...',
    confirm_upload_btn: 'アップロードを確認',
    payment_channel:    '支払いチャンネル',
    wallet_type:        'ウォレット',
    wallet_number_label:'ウォレット番号',
    copy_wallet_no:     'ウォレット番号をコピー',
    truemoney_warning:  'TrueMoneyアプリから上記番号に送金し、LINE Adminで通知してください。5分以内にクレジットが加算されます。',
    cond_pay_1: '指定時間内に確認して支払いを完了してください。',
    cond_pay_2: '支払い後にクレジットが入らない場合は管理者にお問い合わせください。',
    cond_pay_3: '不必要に確認ボタンを複数回押さないでください。',
    cond_slip_1:'送金完了後にスリップをアップロードしてください。',
    cond_slip_2:'画像は鮮明で、金額と送金時間が確認できるものを使用してください。',
    cond_slip_3:'重複または偽のスリップをアップロードしないでください。',
    crypto_title_short:  '暗号通貨',
    crypto_send_note:    '以下のウォレットアドレスに送金してください',
    select_currency:     '通貨を選択',
    wallet_address_label:'ウォレットアドレス',
    min_label_short:     '最低',
    max_label_short:     '最高',
    attach_proof:        '送金証明を添付',
    drag_or_click:       'ドラッグ＆ドロップまたはクリックして選択',
    click_to_change:     'クリックして変更',

    not_logged_in:           'ログインしていません',
    not_logged_in_text:      'ログインしていません',
    select_slip_file:        '振込証明ファイルを選択してください',
    upload_slip_failed:      '証明書のアップロードに失敗しました',
    transaction_done:        '処理が完了しました',
    transaction_failed:      '処理に失敗しました',
    error_occurred:          'エラーが発生しました',
    session_expired:         'セッションが期限切れです。再ログインしてください。',
    game_problem:            'ゲームは現在利用できません。しばらくお待ちください。',
    qr_scan_5min:            '5分以内にQRコードをスキャンしてください',
    force_withdraw_all:      '全額出金が必要です',
    insufficient_withdraw:   '出金残高が不足しています',
    withdraw_success:        '出金申請が完了しました',
    turnover_remaining_prefix: '残りターンオーバー',
    min_withdraw_prefix:     '最低出金額',
    withdraw_error:          '出金に失敗しました。スタッフにお問い合わせください。',
    withdraw_problem:        '出金に問題が発生しました。スタッフにお問い合わせください。',
    change_password_success: 'パスワードを変更しました',
    wrong_old_password:      '現在のパスワードが正しくありません',
    password_error:          'エラーが発生しました。再度お試しください。',
    same_password:           '新しいパスワードは以前と異なる必要があります',
    password_mismatch:       'パスワードが一致しません',
    copy_success:            'コピーしました！',
    select_file_first:       '確認前にファイルを選択してください',
    time_expired:            '期限切れ',
    hour_unit:               '時間',

    truegift_tab:            'トゥルーギフト',
    no_bank_account:         '銀行口座が見つかりません',
    copy_acc_done:           '口座番号をコピーしました！',
    copy_acc_prefix:         '口座番号をコピー',
    select_deposit_amount:   '入金額を選択',
    enter_amount:            '金額を入力',
    bank_transfer_warning:   '登録済みの口座からのみ振り込んでください。他の口座からの振込は自動検出されません。LINE Adminで通知してください。',
    no_autoslip:             'AutoSlipアカウントが見つかりません',
    upload_slip_auto_label:  'スリップをアップロード（自動確認）',
    confirm_upload_slip:     'スリップのアップロードを確認',
    upload_success_checking: 'アップロード完了！システムが確認中...',
    transfer_warning_short:  '登録済みの口座からのみ振り込んでください',
    no_truewallet:           'TrueMoneyウォレットが見つかりません',
    truemoney_phone_label:   'TrueMoneyの電話番号',
    submitting:              '送信中...',
    notify_truemoney_deposit:'TrueMoney入金を通知',
    truemoney_submit_success:'TrueMoney入金を申請しました。確認をお待ちください。',
    deposit_gift_truemoney:  'Gift TrueMoneyで入金',
    gift_paste_hint:         'gift.truemoney.comのギフトリンクを貼り付けて送信',
    gift_link_label:         'TrueMoneyギフトリンク',
    checking:                '確認中...',
    send_gift_link:          'ギフトリンクを送信',
    gift_submit_success:     'ギフトリンクを送信しました。確認をお待ちください。',
    no_payment_gateway:      '支払いゲートウェイが見つかりません',
    pay_via_gateway:         '決済ゲートウェイで支払い',
    contact_admin:           '管理者にお問い合わせください',
    no_crypto:               '暗号通貨ウォレットが見つかりません',
    crypto_thb_label:        '送金する金額（バーツ）を入力',
    crypto_amount_prefix:    '金額',
    crypto_amount_suffix:    '送金が必要',
    crypto_send_only:        '送金できるのは',
    crypto_send_only_suffix: 'のみです',
    crypto_wrong_type_warning:'誤った通貨タイプを送ると資産を失う可能性があります。',
    load_failed_retry:       'データの読み込みに失敗しました。再試行してください。',

    from_last_month:         '先月比',
    withdrawable_income:     '引き出し可能な収益',
    members_this_month:      '今月の会員',
    new_members_today:       '本日の新規会員',
    person_unit:             '人',
    how_to_build_network:    'ネットワークの構築方法',
    seven_days_filter:       '7日間',
    month_filter:            '月',
    new_member_tab:          '新規会員',
    history_all_tab:         '履歴 / すべて',
    active_total:            '総アクティブ数',
    this_month:              '今月',
    all_members:             '全会員',
    total_referred:          '総紹介会員',
    deposited_badge:         '入金済み',
    not_deposited_badge:     '未入金',
    income_summary_all:      '収益サマリー - すべて',
    network_income_total:    'ネットワーク総収益',
    income_this_month:       '今月の収益',
    income_last_month:       '先月の収益',
    aff_easy_rich_tagline:   'Salmon で簡単に稼ごう',
    aff_share_link_tagline:  'リンクをシェアするだけで収益を得られます',
    aff_step1:               '紹介リンクをコピーする',
    aff_step2:               'LINEやSNSで友達にシェアする',
    aff_step3:               '友達が登録して入金する',
    aff_step4:               '自動的に収益を受け取る',
    your_link:               'あなたのリンク',
    aff_tab_overview:        '概要',
    aff_tab_members:         '会員',
    aff_tab_income:          '収益サマリー',
    aff_tab_network:         'ネットワーク',
    aff_claim_success:       '収益の受け取りが完了しました',
    aff_no_balance:          '処理できません — 残高がありません',
    aff_claim_failed:        'リクエストを処理できません',
    user_label:              'ユーザー',

    footer_site_heading:     'フル機能のオンラインカジノ — オンラインスロット、ライブカジノ、ライブバカラ、魚釣りゲーム、スポーツゲームなど。',
    footer_p1:               'プレイヤーは最低10バーツのベットでゲームを楽しめ、24時間自動システムで入出金が可能です。便利で迅速、オンラインゲームファンに最適です。',
    footer_service_heading:  '他に負けない印象的なサービス。24時間365日、毎日すべての質問に誠実に対応します。',
    footer_p2_part1:         'すべてのプレイヤーが私たちにとって大切な存在です。カスタマーリレーションチームが24時間いつでも疑問を解消し、サポートします。また、SA Gamingをはじめとする一流カジノ・スロットパートナーと提携し、多様なゲームと娯楽をお届けします。SA Gaming,',
    footer_p2_part2:         'Gaming、WM Casino、Dream Gaming、Pretty Gaming、ALLBET、Joker、PG Slotなど多数のゲームでプレイヤーを虜にします。',
    footer_p3:               '先進的かつ一流のカジノゲームプロバイダーが網羅的に集結。ニーズに最も応えます。豊富なゲームラインナップ、シンプル操作、飽きることがありません。安定したシステムで常に最新化。リアルなライブ配信で近くからベッティング結果を追え、24時間エキサイティング。evocasinoが新体験を切り開き、圧倒的な感動をお届けします。',
    footer_casino_online:    'オンラインカジノ',
    footer_baccarat_tagline: 'バカラオンラインカジノ — プレイヤーに真の最高体験を。',

    cancel_promo_confirm:    'このプロモーションをキャンセルしますか？',
    action_failed_wait:      '処理できません。しばらくお待ちください。',
    promo_not_eligible:      'このプロモーションの条件を満たしていません。',
    promo_pending_deposit:   'ペンディング中のプロモーションがあります。今すぐ入金できます。',

    promo_join_title:        'プロモーション参加',
    no_transaction_text:     '取引記録がありません。',
    status_label:            'ステータス：',
    status_cancel_player:    'キャンセル（プレイヤー）',
    status_cancel_player_short: 'キャンセル（プレイヤー）',
    status_failed_system:    '失敗（システム）',
    time_unit:               '',

    login_redirecting:       'ログイン成功。リダイレクト中...',
    invalid_credentials:     'ユーザー名またはパスワードが正しくありません。',
    contact_problem_title:   '問題が発生しました',
    contact_support_text:    'カスタマーサポートに連絡',
    phone_invalid:           '電話番号が正しくありません。',
    phone_in_use:            'この電話番号は既に使用されています。',
    rate_limited:            'リクエストが多すぎます。しばらくお待ちください。',
    fill_bank_info:          '銀行を選択するか、情報を入力してください。',
    incomplete_digits:       '番号が不完全です。',
    otp_invalid:             'コードが正しくありません。',
    no_account_number:       '銀行口座番号を入力してください。',
    no_bank_selected:        '銀行を選択してください。',
    invalid_account_number:  '口座番号が無効です。',
    register_success:        '登録完了。しばらくお待ちください。',
    account_already_registered: 'この口座番号は既に登録されています。',
    username_already_taken:  'このユーザー名は既に使用されています。',
    invalid_username_name:   'ユーザー名または氏名が無効です。',
    no_fullname:             '氏名を入力してください。',
    password_max_15:         'パスワードは15文字以内にしてください。',
    password_min_4:          'パスワードは4文字以上にしてください。',
    confirm_password_mismatch: '確認コードが一致しません。',

    rank_claim_confirm:      'ランクをクレームしますか？',
    current_deposit:         '現在の入金額',
    need_deposit:            '入金が必要です',
    not_qualified:           '条件未達',
    processing_label:        '処理中...',
    deposit_baht_up:         'バーツ以上',
    deposit_limit_prefix:    '最低入金',

    loss_calculated_title:   '計算された損失',
    daily_type:              'デイリー',
    weekly_type:             '毎週',
    monthly_type:            '毎月',
    next_round_prefix:       '次のラウンド：',
    total_receivable_cashback: '受取可能なキャッシュバック総額',
    withdrawable_cashback:   '引き出し可能なキャッシュバック',

    coming_soon:             '近日公開',
    toprank_subtitle:        '最新更新 · 最高勝利',

    checkin_success_title:   'チェックイン成功',
    checkin_failed_title:    'チェックイン失敗',
    checkin_error_title:     'チェックインできません',
    checkin_date_wrong:      'チェックイン日付が今日と一致しません。',
    claim_reward_success:    '累積報酬を受け取りました！',
    claim_reward_failed:     '報酬の受け取りに失敗しました',
    checkin_error_msg:       'チェックイン中にエラーが発生しました。',
    try_again:               'もう一度お試しください。',

    login_first_title:       'ログインしてください',
    login_first_text:        '報酬交換前にログインしてください。',
    not_enough_points_title: 'ポイント不足',
    redeem_success_title:    '交換成功！',
    redeem_success_text:     '交換リクエストが記録されました。',
    failed_title:            '失敗',

    announcement_label:      'お知らせ',
    hide_today:              '今日は表示しない',

    textslide_default:       '大型サイト。ユーザーロックなし。10秒で入出金。最低金額なし。ターンオーバーなし。出金無制限。全プロバイダー8%キャッシュバック。0.8%紹介報酬。24時間サポート。',

    promo_daily_used_up:     '本日のプロモーション回数を使い切りました。',
    promo_already_used:      'このプロモーションは既に使用済みです。',
    coupon_success_title:    'クーポン適用完了',
    invalid_coupon:          'このコードはシステムに存在しません。',
    no_current_promo:        '現在アクティブなプロモーションはありません。',
    cancel_promo_title:      'プロモーションをキャンセルしますか？',
    cancel_promo_text:       '現在のプロモーションをキャンセルしますか？',
    cancel_promo_success:    'プロモーションのキャンセルが完了しました。',
    cancel_promo_failed:     'プロモーションをキャンセルできません。',
    current_promo_label:     '現在のプロモーション',
    promo_auto_on_deposit:   '入金時にプロモーションが自動適用されます。',
    cancelling_label:        'キャンセル中...',
    no_promo_selected:       'プロモーションが選択されていません。',
    select_promo_below:      '下からプロモーションを選択できます。',
    terms_conditions:        '利用規約',
    promo_not_active:        'このプロモーションはまだ有効になっていません。',

    cards_used_today:        '本日のカード開封回数を使い切りました。明日またお試しください。',
    not_enough_points_game:  'このゲームのポイントが不足しています。',
    login_first_play:        'プレイする前にログインしてください。',
    select_activity_first:   'プレイ前にアクティビティを選択してください。',
    card_reshuffle_title:    'カードをリセットします。',
    card_reshuffle_text:     '「OK」を押して再シャッフルしてください。',
    open_card_event_title:   'カード開封イベント',
    points_available_label:  '使用可能ポイント',
    point_unit:              'ポイント',
    enter_game_btn:          'プレイ',
    open_card_btn:           'カードを開く',
    card_shuffled_done:      'シャッフル完了！',
    card_event_conditions:   '参加条件',
    no_condition_found:      '開封条件：未確認',
    can_open_per_day:        '1日2回のみ開封可能。',
    detail_label:            '詳細：',
    card_history_col:        '取引履歴',
    card_history_title:      'カードゲーム履歴',
    all_records:             'すべて',
    no_records_found:        '記録が見つかりません...',
    time_col:                '時刻',
    amount_label_col:        '金額',

    you_have_label:          'お持ちの',
    needed_label:            '必要',
    redeem_verb:             '交換',
    use_verb_label:          '使用',
    to_redeem_for_label:     'と交換',
    today_text:              '今日',
    this_week_text:          '今週',

    cashback_success_notify: 'キャッシュバックを受け取りました。',
    cashback_no_balance:     '処理できません — 残高なし。',
    cashback_failed:         'トランザクションを処理できません。',
    not_logged_in:           'ログインしていません。',

    process_success:         '処理が完了しました',
    deposit_max_label:       'バーツ 最高',
    bonus_label:             'ボーナス',
  },

  my: {
    confirm:        'အတည်ပြုမည်',
    cancel:         'မလုပ်တော့',
    save:           'သိမ်းမည်',
    back:           'နောက်သို့',
    close:          'ပိတ်မည်',
    copy:           'ကူးယူမည်',
    copied:         'ကူးယူပြီးပြီ!',
    loading:        'တင်နေသည်...',
    error:          'အမှားဖြစ်ပွားသည်',
    success:        'အောင်မြင်သည်',
    submit:         'တင်သွင်းမည်',
    or:             'သို့မဟုတ်',
    contact:        'ဆက်သွယ်မည်',
    baht:           'ဘတ်',
    ok:             'ကောင်းပြီ',
    search:         'ရှာဖွေမည်',
    more:           'ပိုမိုကြည့်ရှုမည်',
    no_data:        'ဒေတာမရှိ',

    home:           'ပင်မစာမျက်နှာ',
    deposit:        'ငွေဖြည့်မည်',
    withdraw:       'ငွေထုတ်မည်',
    history:        'မှတ်တမ်း',
    promotion:      'ပရိုမိုးရှင်း',
    affiliate:      'မိတ်ဆက်ပေးသူ',
    cashback:       'ငွေပြန်အမ်း',
    toprank:        'အဆင့်ထိပ်ဆုံး',
    redeem_reward:  'ဆုကြေးယူမည်',
    rebate:         'ဆုကြေးပြန်အမ်း',
    profile:        'ကိုယ်ရေးအချက်အလက်',
    logout:         'ထွက်ခွာမည်',
    login:          'ဝင်ရောက်မည်',
    register:       'အသင်းဝင်မည်',
    lucky_fortune:  'ကံစမ်းဘီး',
    check_in:       'နေ့စဉ်စစ်ဆေး',
    event:          'ပွဲကစားမည်',
    casino:         'ကာစီနို',
    slot:           'ဆလော့',
    fishing:        'ငါးဖမ်းဂိမ်း',
    sport:          'အားကစား',
    lotto:          'ထီ',
    card_game:      'ဖဲဂိမ်း',

    menu_home:      'ပင်မ',
    menu_deposit:   'ဖြည့်',
    menu_contact:   'ဆက်သွယ်',
    menu_promotion: 'ပရိုမို',
    menu_profile:   'အကောင့်',

    login_title:      'ဝင်ရောက်မည်',
    login_phone:      'ဖုန်းနံပါတ်ဖြင့်ဝင်ရောက်',
    username_label:   'ဖုန်းနံပါတ်',
    password_label:   'စကားဝှက်',
    forgot_password:  'စကားဝှက်မေ့သွားသည်',
    no_account:       'အကောင့်မရှိသေးဘူး?',
    register_now:     'အသင်းဝင်မည်',
    login_btn:        'ဝင်ရောက်မည်',

    register_title:     'အသင်းဝင်မည်',
    firstname:          'နာမည်-မျိုးနွယ်',
    phone_number:       'ဖုန်းနံပါတ်',
    confirm_password:   'စကားဝှက်အတည်ပြုမည်',
    invite_code:        'ဖိတ်ကြားကုဒ် (ရှိရင်)',
    have_account:       'အကောင့်ရှိနှင့်ပြီးသားဘူး?',
    login_now:          'ဝင်ရောက်မည်',
    select_bank:        'ဘဏ်ရွေးမည်',
    account_number_label: 'ဘဏ်အကောင့်နံပါတ်',
    register_btn:       'အသင်းဝင်မည်',

    deposit_title:      'ငွေဖြည့်မည်',
    bank_tab:           'ဘဏ်',
    truemoney_tab:      'ထရူမော်နီ',
    payment_tab:        'ငွေပေးချေမည်',
    upload_slip_tab:    'ဆလစ်တင်မည်',
    account_name:       'အကောင့်နာမည်',
    bank_name:          'ဘဏ်',
    min_amount:         'အနည်းဆုံး',
    max_amount:         'အများဆုံး',
    amount_label:       'ပမာဏ (ဘတ်)',
    amount_placeholder: 'ပမာဏထည့်ပါ',
    quick_fill:         'မြန်မြန်ဖြည့်မည်',
    scan_qr:            'QR Code ဖတ်ပြီး ငွေပေးချေမည်',
    upload_slip:        'ဆလစ်တင်မည်',
    drag_drop_text:     'ဓာတ်ပုံဆွဲ၍ ချထားပါ သို့မဟုတ် ဖိုင်ရွေးမည်',
    select_file:        'ဖိုင်ရွေးမည်',
    conditions_title:   'ငွေဖြည့်အခြေအနေ',
    confirm_deposit:    'ငွေဖြည့်မည်ကိုအတည်ပြုမည်',
    copy_account:       'ကူးယူမည်',
    deposit_to:         'သို့လွှဲပြောင်းမည်',
    upload_success:     'တင်သွင်းအောင်မြင်ပြီ!',
    upload_success_desc:'သင်၏ဆလစ်ကိုပို့ပြီးပြီ',
    supported_format:   'JPG, PNG, WEBP ကိုထောက်ခံ၊ 5MB အောက်ဖြစ်ရမည်',
    change_slip:        'ဓာတ်ပုံပြောင်းမည်',
    create_qr:          'ငွေပေးချေရန် QR Code ပြုလုပ်မည်',
    confirm_payment:    'ငွေပေးချေမည်ကိုအတည်ပြုမည်',
    promptpay_only:     'PromptPay / ဘဏ်သာ',
    confirm_upload:     'တင်သွင်းမည်ကိုအတည်ပြုမည်',
    uploading:          'တင်သွင်းနေသည်...',
    upload_slip_title:  'ဆလစ်တင်မည်',
    upload_slip_desc:   'ငွေလွှဲမှတ်တမ်းပူးတွဲမည်',
    upload_success_title: 'ဆလစ်တင်သွင်းအောင်မြင်ပြီ',
    processing:         'စနစ်စစ်ဆေးနေသည်၊ ကျေးဇူးပြု၍ ခေတ္တစောင့်ပါ',
    reupload:           'ပြန်တင်မည်',
    upload_conditions_title: 'ဆလစ်တင်သွင်းအခြေအနေ',
    tap_select_image:   'ဆလစ်ဓာတ်ပုံရွေးရန် နှိပ်ပါ',
    go_promotion:       'ပရိုမိုးရှင်းစာမျက်နှာသို့သွားမည်',

    crypto_tab:         'ကရစ်ပတို',
    crypto_currency:    'ငွေကြေး',
    crypto_network:     'ကွန်ရက်',
    crypto_address:     'ပိုက်ဆံပြင်လိပ်စာ',
    crypto_scan_qr:     'QR ဖတ်ပြီး လွှဲမည်',
    crypto_copy:        'လိပ်စာကူးယူမည်',
    crypto_upload_slip: 'လွှဲမှတ်တမ်းပူးတွဲမည်',
    crypto_note:        'မှတ်ချက်: ငွေကြေးနှင့်ကွန်ရက်မှန်ကန်ကြောင်းသေချာပါ မဟုတ်ပါကငွေဆုံးမည်',
    crypto_rate_note:   'လဲလှယ်နှုန်းကို ငွေလွှဲချိန်တွင် ရည်ညွှန်းသည်',
    crypto_confirm:     'လွှဲမည်ကိုအတည်ပြုမည်',

    withdraw_title:    'ငွေထုတ်မည်',
    withdraw_amount:   'ထုတ်လိုသောပမာဏ',
    select_amount:     'ပမာဏရွေးမည်',
    withdraw_to:       'ဤအကောင့်သို့ထုတ်မည်',
    withdraw_min:      'အနည်းဆုံးထုတ်မည်',
    withdraw_max:      'အများဆုံးထုတ်မည်',
    available_balance: 'ကျန်ငွေ',
    confirm_withdraw:  'ထုတ်မည်ကိုအတည်ပြုမည်',

    profile_title:    'ကိုယ်ရေးအချက်အလက်',
    account_info:     'အကောင့်အချက်အလက်',
    fullname:         'နာမည်-မျိုးနွယ်',
    rank:             'အဆင့်',
    credit:           'ကရက်ဒစ်',
    point:            'မှတ်',
    change_password:  'စကားဝှက်ပြောင်းမည်',
    old_password:     'ဟောင်းစကားဝှက်',
    new_password:     'အသစ်စကားဝှက်',
    account_number:   'အကောင့်နံပါတ်',

    history_title:   'ငွေကြေးမှတ်တမ်း',
    all_type:        'အားလုံး',
    deposit_type:    'ငွေဖြည့်',
    withdraw_type:   'ငွေထုတ်',
    bonus_type:      'ဘောနပ်',
    date_col:        'ရက်',
    amount_col:      'ပမာဏ',
    status_col:      'အခြေအနေ',
    status_approve:  'အောင်မြင်',
    status_pending:  'စောင့်ဆိုင်းနေ',
    status_reject:   'ပြန်ပယ်ချ',

    promotion_title: 'ပရိုမိုးရှင်း',
    apply_promo:     'ပရိုမိုးရှင်းရယူမည်',
    in_use_promo:    'အသုံးပြုနေသည်',
    promo_full:      'ပြည့်နေပြီ',
    promo_available: 'ရနိုင်သည်',
    promo_detail:    'အသေးစိတ်',
    no_promotion:    'ပရိုမိုးရှင်းမရှိ',
    cancel_promo:    'ပရိုမိုးရှင်းဖျက်သိမ်းမည်',
    min_deposit:     'အနည်းဆုံးဖြည့်',
    bonus_percent:   'ဘောနပ်',
    max_withdraw:    'အများဆုံးထုတ်နိုင်',
    turn_over:       'တာနိုဗာ',

    affiliate_title: 'မိတ်ဆက်ပေးသူ',
    invite_link:     'ဖိတ်ကြားလင်',
    today_income:    'ယနေ့ဝင်ငွေ',
    total_income:    'စုစုပေါင်းဝင်ငွေ',
    member_count:    'အဖွဲ့ဝင်အရေအတွက်',
    withdraw_btn:    'ငွေထုတ်မည်',
    share_line:      'LINE မျှဝေမည်',

    cashback_title:    'ငွေပြန်အမ်း',
    period_label:      'ကာလ',
    eligible_amount:   'ပြန်ရနိုင်သောပမာဏ',
    cashback_rate:     'ပြန်နှုန်း',
    receive_cashback:  'ငွေပြန်အမ်းရယူမည်',
    cashback_history:  'ရယူမှတ်တမ်း',

    rebate_title:   'ထိုးငွေပြန်အမ်း',
    rebate_amount:  'ထိုးပမာဏ',
    receive_rebate: 'ပြန်ရယူမည်',

    toprank_title: 'အဆင့်ထိပ်ဆုံး',
    rank_col:      'အဆင့်',
    username_col:  'အသုံးပြုသူ',
    credit_col:    'ကရက်ဒစ်',

    redeem_title:   'ဆုကြေးလဲလှယ်မည်',
    redeem_btn:     'လဲမည်',
    my_points:      'ကျွန်ုပ်၏မှတ်',
    required_points:'လိုအပ်သောမှတ်',

    spin_btn:       'လှည့်မည်',
    spin_free:      'အခမဲ့',
    spin_remaining: 'ကျန်ကြိမ်',
    checkin_day:    'ရက်',
    checkin_title:  'နေ့စဉ်စစ်ဆေး',
    checkin_btn:    'စစ်ဆေးမည်',
    checkin_done:   'စစ်ဆေးပြီးပြီ',

    language_label:    'Language / ဘာသာ',
    footer_seo_title:  'ပြည့်စုံသောအွန်လိုင်းကာစီနို',
    footer_desc:       '24 နာရီ အော်တိုဖြည့်/ထုတ်ဝန်ဆောင်မှု',

    event_title: 'ပွဲကစားမည်',

    register_phone_subtitle: 'ဖုန်းနံပါတ်ဖြင့်အသင်းဝင်မည်',
    referrer:                'ညွှန်းသူ',
    next:                    'ဆက်မည်',
    password_step:           'စကားဝှက်',
    select_bank_title:       'ဘဏ်ရွေးပါ',
    account_no_placeholder:  'အကောင့်နံပါတ်',
    account_name_placeholder:'အကောင့်နာမည်',
    contact_btn:             'ဆက်သွယ်မည်',

    checkin_activity_title:        'စစ်ဆေးမှုလုပ်ဆောင်ချက်',
    checkin_subtitle:              'ဝင်လာ၍ နေ့စဉ်စစ်ဆေးပြီး ဆုများရယူပါ',
    checkin_min_deposit_prefix:    'ငွေဖြည့်',
    checkin_min_deposit_suffix:    '.- ကျပ်နှင့်အထက်',
    today:                         'ယနေ့',
    checkin_monthly:               'ဤလ စစ်ဆေးမှုစုဆောင်းမှု',
    max_label:                     'အများဆုံး',
    day_unit:                      'ရက်',

    my_points_label:    'သင်၏မှတ်',
    reward_items_tab:   'ဆုကြေး',
    redeem_history_tab: 'လဲလှယ်မှတ်တမ်း',
    no_rewards_yet:     'ဆုကြေးမရှိသေးဘူး',
    no_redeem_history:  'လဲလှယ်မှတ်တမ်းမရှိသေးဘူး',
    stock_remaining:    'ကျန်',
    out_of_stock:       'ကုန်သွားပြီ',
    redeem_now:         'ယခုပဲလဲမည်',
    not_enough_points:  'မှတ်မလုံလောက်',

    lucky_wheel_title:          'ကံစမ်းဘီး',
    spin_wheel_btn:             'ဘီးလှည့်မည်',
    lucky_wheel_alt:            'ကံစမ်းဘီး သည်မျော်ဘီး',
    invite_success:             'ငွေရယူမှုအောင်မြင်ပြီ',
    invite_no_balance:          'ငွေပမာဏမရှိ၍ မလုပ်နိုင်',
    action_failed:              'လုပ်ဆောင်မှုမအောင်မြင်',
    wheel_conditions_title:     'ဝန်ဆောင်မှုအခြေအနေ',
    wheel_cond_deposit:         '• ဘတ် ၁,၀၀၀ စုဆောင်းဖြည့်ပါက ၁ ကတ်ရမည် (နေ့တစ်နေ့ ၅ ကတ်အများဆုံး)',
    wheel_cond_reset_prefix:    '• ဖြည့်ငွေစုဆောင်းမှုကို',
    wheel_cond_reset_value:     '0 ပြန်ညှိမည်',
    wheel_cond_reset_suffix:    'နေ့တိုင်း 00:00 တွင်',
    wheel_cond_ticket_note:     '*ဤစာမျက်နှာကိုဝင်ကြည့်မှသာ ဘီးကတ်ကိုတွက်ချက်ပြီးရရှိမည်',
    wheel_cond_no_entry:        'မဝင်ကြည့်ပါကမရ',

    popular:          'နာမည်ကြီး',
    esport:           'အီးစပို',
    slots_popular:    'နာမည်ကြီးဆလော့',
    casino_popular:   'နာမည်ကြီးကာစီနို',
    lucky_wheel_short:'ဘီး',
    open_card:        'ဖဲဖွင့်မည်',
    open_card_event:  'ဖဲဖွင့်ပွဲ',
    checkin_short:    'စစ်ဆေး',
    loss_cashback:    'ငွေပြန်ရယူမည်',
    loss_short:       'ရှုံးငွေ',
    deposit_problem:  'ငွေဖြည့်မှုပြဿနာဖြစ်ပါက ဝန်ထမ်းကိုဆက်သွယ်ပါ',

    trading:          'ကုန်သွယ်ရေး',
    play_btn:         'ဝင်ကစား',
    not_open_yet:     'မဖွင့်သေးဘူး',
    play_game:        'ဂိမ်းကစားမည်',

    your_account:       'သင်၏အကောင့်',
    transfer_note_only: 'စနစ်ညွှန်ပြသောအကောင့်မှသာ လွှဲပြောင်းပါ',
    bank_dest:          'ဦးတည်ဘဏ်',
    savings_type:       'စုဆောင်း',
    acc_no_label:       'အကောင့်နံပါတ်',
    copy_acc_no:        'အကောင့်နံပါတ်ကူးယူမည်',
    notify_transfer_done: 'ငွေလွှဲကြောင်းအသိပေးပြီးပြီ',
    notify_transfer:    'ငွေလွှဲကြောင်းအသိပေးမည်',
    transfer_warning:   'ငွေလွှဲပြီး ၅ မိနစ်အတွင်းအသိပေးပါ',
    uploading_slip:     'ဆလစ်တင်သွင်းနေသည်...',
    confirm_upload_btn: 'တင်သွင်းမည်ကိုအတည်ပြုမည်',
    payment_channel:    'ငွေပေးချေမှုလမ်းကြောင်း',
    wallet_type:        'ပိုက်ဆံအိတ်',
    wallet_number_label:'ပိုက်ဆံအိတ်နံပါတ်',
    copy_wallet_no:     'ပိုက်ဆံအိတ်နံပါတ်ကူးယူမည်',
    truemoney_warning:  'TrueMoney app မှ အထက်ပါနံပါတ်သို့ ငွေလွှဲပြီး LINE Admin ကိုအသိပေးပါ ၅ မိနစ်အတွင်း ကရက်ဒစ်ဖြည့်မည်',

    cond_pay_1: 'အတည်ပြုပြီး သတ်မှတ်ချိန်အတွင်း ငွေပေးချေပါ',
    cond_pay_2: 'ငွေပေးချေပြီးကရက်ဒစ်မဝင်ပါက Admin ကိုဆက်သွယ်ပါ',
    cond_pay_3: 'မလိုအပ်ဘဲ အတည်ပြုခလုတ်ထပ်မနှိပ်ပါနှင့်',
    cond_slip_1:'ငွေလွှဲပြီးမှသာ ဆလစ်တင်ပါ',
    cond_slip_2:'ရုပ်ပုံရှင်းလင်းရမည်၊ ပမာဏနှင့်ချိန်ကိုမြင်ရရမည်',
    cond_slip_3:'ဆလစ်ထပ်တင်ခြင်း သို့မဟုတ် အတုဆလစ်တင်ခြင်းမလုပ်ပါနှင့်',

    qr_for_payment:      'ငွေပေးချေရန် QR Code',
    scan_once_only:      'QR Code ကို တစ်ကြိမ်သာဖတ်ပြီးပေးချေပါ၊ ထပ်မဖတ်ပါနှင့်',
    pay_within_time:     'သတ်မှတ်ချိန်အတွင်း ငွေပေးချေပါ',
    cancel_transaction:  'ငွေပေးချေမှုဖျက်မည်',
    new_transaction:     'ကျေးဇူးပြု၍ ပြန်လုပ်ဆောင်ပါ',
    payment_via_system:  'Payment စနစ်မှ ငွေပေးချေမည်',
    min_deposit_note:    'အနည်းဆုံးဖြည့် {min} ဘတ် အများဆုံး {max} ဘတ်',
    cond_slip_4:         'စနစ်စစ်ဆေးပြီး ၅ မိနစ်အတွင်း ကရက်ဒစ်ဖြည့်မည်',
    cond_slip_5:         'ပြဿနာဖြစ်ပါက Line မှ Admin ကိုဆက်သွယ်ပါ',
    confirm_transfer:    'လွှဲမည်ကိုအတည်ပြုမည်',
    crypto_warning_net:  'ပြသထားသောငွေကြေးနှင့်ကွန်ရက်မှန်ကန်ကြောင်းသေချာပါ မဟုတ်ပါကငွေဆုံးမည်ပြီး ပြန်မရနိုင်',
    exchange_rate_note:  'လဲလှယ်နှုန်းကို ငွေလွှဲချိန်တွင် ရည်ညွှန်းသည်',
    game_balance:        'ဂိမ်းထဲ ငွေပမာဏ',
    mission_label:       'မစ်ရှင်',
    sec_unit:            'စက္ကန့်',
    notify_slip_warning: 'ငွေလွှဲပြီး ၅ မိနစ်အတွင်းအသိပေးပါ၊ ကျော်လွန်ပါကစနစ်မှ အလိုအလျောက်ဖျက်မည်',

    crypto_title_short:  'ကရစ်ပတို',
    crypto_send_note:    'အောက်ပါပိုက်ဆံပြင်လိပ်စာသို့ ကရစ်ပတိုငွေလွှဲပါ',
    select_currency:     'ငွေကြေးရွေးမည်',
    wallet_address_label:'ပိုက်ဆံပြင်လိပ်စာ',
    min_label_short:     'အနည်းဆုံး',
    max_label_short:     'အများဆုံး',
    attach_proof:        'လွှဲမှတ်တမ်းပူးတွဲမည်',
    drag_or_click:       'ဆွဲ၍ ချထားပါ သို့မဟုတ် ရွေးမည်',
    click_to_change:     'ပြောင်းရန် နှိပ်ပါ',

    not_logged_in:           'ဝင်ရောက်မထားသေးဘူး',
    not_logged_in_text:      'သင်မဝင်ရောက်ရသေးဘူး',
    select_slip_file:        'ဆလစ်ဖိုင်ရွေးပါ',
    upload_slip_failed:      'ဆလစ်တင်မအောင်မြင်',
    transaction_done:        'လုပ်ဆောင်မှုပြီးပြီ',
    transaction_failed:      'ငွေလွှဲမအောင်မြင်',
    error_occurred:          'အမှားဖြစ်ပွားသည်',
    session_expired:         'Session မပျောက်ဘဲ ပြန်ဝင်ပါ',
    game_problem:            'ဂိမ်းပြဿနာဖြစ်နေ၍ ခေတ္တစောင့်ပါ',
    qr_scan_5min:            'QR Code ကို ၅ မိနစ်အတွင်း ဖတ်ပါ',
    force_withdraw_all:      'ငွေအားလုံးကို ဖျက်ငွေထုတ်မည်',
    insufficient_withdraw:   'ထုတ်ရန်ငွေပမာဏမလုံလောက်',
    withdraw_success:        'ငွေထုတ်မှုပြီးပြီ',
    turnover_remaining_prefix: 'တာနိုဗာ ကျန်ရှိ',
    min_withdraw_prefix:     'အနည်းဆုံးထုတ်မည်',
    withdraw_error:          'ငွေထုတ်မလုပ်နိုင်၊ ဝန်ထမ်းကိုဆက်သွယ်ပါ',
    withdraw_problem:        'ငွေထုတ်ပြဿနာဖြစ်နေ ဝန်ထမ်းကိုဆက်သွယ်ပါ',
    change_password_success: 'စကားဝှက်ပြောင်းပြီးပြီ',
    wrong_old_password:      'ဟောင်းစကားဝှက်မှားသည်',
    password_error:          'အမှားဖြစ်ပွားသည်၊ ထပ်မံကြိုးစားပါ',
    same_password:           'အသစ်စကားဝှက်သည် ဟောင်းစကားဝှက်နှင့် တူသည်',
    password_mismatch:       'စကားဝှက်မတိုက်ဆိုင်',
    copy_success:            'ကူးယူပြီးပြီ',
    select_file_first:       'ဖိုင်ကိုဦးစွာရွေးပါ',
    time_expired:            'အချိန်ကုန်ပြီ',
    hour_unit:               'နာရီ',

    truegift_tab:            'TrueMoney လက်ဆောင်',
    no_bank_account:         'ဘဏ်အကောင့်မတွေ့',
    copy_acc_done:           'အကောင့်နံပါတ်ကူးယူပြီးပြီ!',
    copy_acc_prefix:         'အကောင့်နံပါတ်ကူးယူမည်',
    select_deposit_amount:   'ဖြည့်မည့်ပမာဏရွေးမည်',
    enter_amount:            'ပမာဏထည့်ပါ',
    bank_transfer_warning:   'မှတ်ပုံတင်ထားသောအကောင့်မှသာ လွှဲပါ မဟုတ်ပါက LINE Admin ကိုအသိပေးပါ',
    no_autoslip:             'AutoSlip အကောင့်မတွေ့',
    upload_slip_auto_label:  'ဆလစ်တင်မည် (အော်တိုစစ်ဆေးမည်)',
    confirm_upload_slip:     'ဆလစ်တင်မည်ကိုအတည်ပြုမည်',
    upload_success_checking: 'တင်သွင်းပြီးပြီ! စစ်ဆေးနေသည်...',
    transfer_warning_short:  'မှတ်ပုံတင်ထားသောအကောင့်မှသာ လွှဲပါ',
    no_truewallet:           'TrueMoney အကောင့်မတွေ့',
    truemoney_phone_label:   'သင်၏ TrueMoney ဖုန်းနံပါတ်',
    submitting:              'ဒေတာပို့နေသည်...',
    notify_truemoney_deposit:'TrueMoney ဖြည့်ကြောင်းအသိပေးမည်',
    truemoney_submit_success:'TrueMoney ဖြည့်ကြောင်းအသိပေးပြီးပြီ စစ်ဆေးစောင့်ပါ',
    deposit_gift_truemoney:  'TrueMoney Gift ဖြင့်ဖြည့်မည်',
    gift_paste_hint:         'gift.truemoney.com မှ Gift လင်ကပ်ပြီးပို့ပါ',
    gift_link_label:         'TrueMoney Gift လင်',
    checking:                'စစ်ဆေးနေသည်...',
    send_gift_link:          'Gift လင်ပို့မည်',
    gift_submit_success:     'Gift လင်ပို့ပြီးပြီ စစ်ဆေးစောင့်ပါ',
    no_payment_gateway:      'Payment Gateway မတွေ့',
    pay_via_gateway:         'Payment Gateway မှ ငွေပေးချေမည်',
    contact_admin:           'Admin ကိုဆက်သွယ်ပါ',
    no_crypto:               'ကရစ်ပတိုပိုက်ဆံပြင်မတွေ့',
    crypto_thb_label:        'လွှဲမည့်ပမာဏ (ဘတ်) ထည့်ပါ',
    crypto_amount_prefix:    'ပမာဏ',
    crypto_amount_suffix:    'လွှဲရမည်',
    crypto_send_only:        'ကျေးဇူးပြု၍ သာ',
    crypto_send_only_suffix: 'ကိုသာ ပို့ပါ',
    crypto_wrong_type_warning:'မမှန်ကန်သောငွေကြေးများ ပို့ပါကဆုံးရှုံးနိုင်',
    load_failed_retry:       'ဒေတာတင်မကြ ထပ်မံကြိုးစားပါ',

    from_last_month:         'ပြီးခဲ့သောလမှ',
    withdrawable_income:     'ထုတ်နိုင်သောဝင်ငွေ',
    members_this_month:      'ဤလ အဖွဲ့ဝင်',
    new_members_today:       'ယနေ့ အဖွဲ့ဝင်သစ်',
    person_unit:             'ဦး',
    how_to_build_network:    'ကွန်ရက်တည်ဆောက်နည်း',
    seven_days_filter:       '၇ ရက်',
    month_filter:            'လ',
    new_member_tab:          'အဖွဲ့ဝင်သစ်',
    history_all_tab:         'မှတ်တမ်း/အားလုံး',
    active_total:            'စုစုပေါင်းတက်ကြွ',
    this_month:              'ဤလ',
    all_members:             'အဖွဲ့ဝင်အားလုံး',
    total_referred:          'ညွှန်းထားသောအဖွဲ့ဝင်',
    deposited_badge:         'ဖြည့်ပြီးပြီ',
    not_deposited_badge:     'မဖြည့်ရသေးဘူး',
    income_summary_all:      'ဝင်ငွေသုံးသပ်ချက် အားလုံး',
    network_income_total:    'ကွန်ရက်မှ ဝင်ငွေ အားလုံး',
    income_this_month:       'ဤလ ဝင်ငွေ',
    income_last_month:       'ပြီးခဲ့သောလ ဝင်ငွေ',
    aff_easy_rich_tagline:   'Salmon နှင့် လွယ်ကူစွာ ကြွယ်ဝပါ',
    aff_share_link_tagline:  'လင်မျှဝေပြီး ဝင်ငွေရပါ',
    aff_step1:               'မိတ်ဆက်လင်ကူးယူပါ',
    aff_step2:               'Line သို့မဟုတ် Social Media မှ မျှဝေပါ',
    aff_step3:               'သူငယ်ချင်းများ သင်ဖြင့် ဝင်ပြီး ငွေဖြည့်ကြသည်',
    aff_step4:               'ဝင်ငွေချက်ချင်းအလိုအလျောက်ရမည်',
    your_link:               'သင်၏လင်',
    aff_tab_overview:        'ခြုံငုံသုံးသပ်ချက်',
    aff_tab_members:         'အဖွဲ့ဝင်',
    aff_tab_income:          'ဝင်ငွေသုံးသပ်ချက်',
    aff_tab_network:         'ကွန်ရက်',
    aff_claim_success:       'ငွေရယူမှုအောင်မြင်ပြီ',
    aff_no_balance:          'ငွေပမာဏမရှိ၍ မလုပ်နိုင်',
    aff_claim_failed:        'မလုပ်နိုင်',
    user_label:              'ယူဇာ',

    footer_site_heading:     'ကာစီနိုအွန်လိုင်းဝန်ဆောင်မှု၊ ဆလော့၊ ကာစီနိုမျက်နှာချင်းဆိုင်၊ ဘာကာရာ၊ ငါးဖမ်းဂိမ်း၊ အားကစား ပြည့်ပြည့်ဝဝ',
    footer_p1:               'ကျွန်ုပ်တို့၏ဂိမ်းများကို ၁၀ ဘတ်မှ ကစားနိုင်ပြီး ၂၄ နာရီ ဖြည့်/ထုတ်လုပ်နိုင်သည်',
    footer_service_heading:  '24 နာရီ 7 ရက် ဝန်ဆောင်မှုကောင်းမွန်သည်',
    footer_p2_part1:         'ကျွန်ုပ်တို့၏ ဖောက်သည်ဆက်ဆံရေးအဖွဲ့သည် ၂၄ နာရီ မေးခွန်းများကို ဖြေကြားပေးပါမည်',
    footer_p2_part2:         'Gaming, WM Casino, Dream Gaming, Pretty Gaming, ALLBET, Joker, PG Slot နှင့် အခြားများ',
    footer_p3:               'ကာစီနိုဂိမ်းပြည့်ဝသောအတွေ့အကြုံ၊ တိုက်ရိုက်ထုတ်လွှင့်မှုနှင့် ၂၄ နာရီ ကစားနိုင်သည်',
    footer_casino_online:    'အွန်လိုင်းကာစီနို',
    footer_baccarat_tagline: 'ဘာကာရာ အကောင်းဆုံးအွန်လိုင်းကာစီနို',

    cancel_promo_confirm:    'ပရိုမိုးရှင်းကို ဖျက်သိမ်းလိုသည်ဟုတ်သလား?',
    action_failed_wait:      'မလုပ်နိုင်ပါ ခေတ္တစောင့်ပါ',
    promo_not_eligible:      'ဤပရိုမိုးရှင်းအခြေအနေမပြည့်မည်',
    promo_pending_deposit:   'ပရိုမိုးရှင်းကျန်ရှိ ငွေဖြည့်နိုင်သည်',

    promo_join_title:        'ပရိုမိုးရှင်းဝင်ရောက်မှု',
    no_transaction_text:     'ငွေကြေးမှတ်တမ်းမရှိသေးဘူး',
    status_label:            'အခြေအနေ :',
    status_cancel_player:    'ဖျက်သိမ်း (ကစားသူမှ ဖျက်သိမ်း)',
    status_cancel_player_short: 'ဖျက်သိမ်း (ကစားသူ)',
    status_failed_system:    'မအောင်မြင် (စနစ်မှ)',
    time_unit:               'နာရီ',

    login_redirecting:       'ဝင်ရောက်နေ လမ်းကြောင်းပြောင်းနေသည်',
    invalid_credentials:     'အသုံးပြုသူနာမည် သို့မဟုတ် စကားဝှက်မမှန်',
    contact_problem_title:   'ပြဿနာတွေ့ရှိ',
    contact_support_text:    'ဖောက်သည်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ',
    phone_invalid:           'ဖုန်းနံပါတ်မှားသည်',
    phone_in_use:            'ဤဖုန်းနံပါတ်ကို သုံးနေပြီ',
    rate_limited:            'မကြာခဏ လုပ်ဆောင်နေသည် ခေတ္တစောင့်ပါ',
    fill_bank_info:          'ဘဏ်ရွေးပြီး အချက်အလက်ပြည့်ပြည့်ဝဝထည့်ပါ',
    incomplete_digits:       'ဂဏန်းမပြည့်',
    otp_invalid:             'ကုဒ်မမှန်',
    no_account_number:       'ဘဏ်အကောင့်နံပါတ်မထည့်ရသေးဘူး',
    no_bank_selected:        'ဘဏ်မရွေးရသေးဘူး',
    invalid_account_number:  'အကောင့်နံပါတ်မမှန်',
    register_success:        'အသင်းဝင်ပြီးပြီ ခေတ္တစောင့်ပါ',
    account_already_registered: 'ဤအကောင့်နံပါတ်မှတ်ပုံတင်ပြီးပြီ',
    username_already_taken:  'ဤ Username မှတ်ပုံတင်ပြီးပြီ',
    invalid_username_name:   'Username သို့မဟုတ် နာမည်မမှန်',
    no_fullname:             'နာမည်-မျိုးနွယ်မထည့်ရသေးဘူး',
    password_max_15:         'စကားဝှက် ၁၅ လုံးအတွင်းဖြစ်ရမည်',
    password_min_4:          'စကားဝှက် ၄ လုံးနည်းမသင့်',
    confirm_password_mismatch: 'အတည်ပြုစကားဝှက်မတိုက်ဆိုင်',

    rank_claim_confirm:      'Rank ကလိမ်လုပ်လိုသည်ဟုတ်သလား?',
    current_deposit:         'လက်ရှိဖြည့်ပမာဏ',
    need_deposit:            'ဖြည့်ရမည့်ပမာဏ',
    not_qualified:           'အခြေအနေမပြည့်သေးဘူး',
    processing_label:        'လုပ်ဆောင်နေသည်...',
    deposit_baht_up:         'ဘတ်နှင့်အထက်',
    deposit_limit_prefix:    'အနည်းဆုံးဖြည့်',

    loss_calculated_title:   'တွက်ချက်ထားသော ရှုံးပမာဏ',
    daily_type:              'နေ့စဉ်',
    weekly_type:             'အပတ်စဉ်',
    monthly_type:            'လစဉ်',
    next_round_prefix:       'ရှေ့ကာလ:',
    total_receivable_cashback: 'စုစုပေါင်းရနိုင်သောငွေပြန်',
    withdrawable_cashback:   'ထုတ်နိုင်သောငွေပြန်',

    coming_soon:             'မကြာမီ',
    toprank_subtitle:        'နောက်ဆုံးအပ်ဒိတ် · အများဆုံးနိုင်ပမာဏ',

    checkin_success_title:   'စစ်ဆေးမှုအောင်မြင်ပြီ',
    checkin_failed_title:    'စစ်ဆေးမှုမအောင်မြင်',
    checkin_error_title:     'စစ်ဆေးမဖြစ်နိုင်',
    checkin_date_wrong:      'စစ်ဆေးသောရက်ယနေ့နှင့်မကိုက်',
    claim_reward_success:    'ဆုကြေးရယူပြီးပြီ',
    claim_reward_failed:     'ဆုကြေးရယူမအောင်မြင်',
    checkin_error_msg:       'စစ်ဆေးမှုတွင် အမှားဖြစ်ပွားသည်',
    try_again:               'ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ',

    login_first_title:       'ကျေးဇူးပြု၍ ဝင်ရောက်ပါ',
    login_first_text:        'ဆုကြေးလဲလှယ်ရန် ဦးစွာဝင်ရောက်ပါ',
    not_enough_points_title: 'မှတ်မလုံလောက်',
    redeem_success_title:    'လဲလှယ်မှုအောင်မြင်ပြီ!',
    redeem_success_text:     'သင်၏ဆုကြေးလဲလှယ်မှုကိုမှတ်တမ်းတင်ပြီးပြီ',
    failed_title:            'မအောင်မြင်',

    announcement_label:      'ကြေညာချက်',
    hide_today:              'ယနေ့မပြတော့',

    textslide_default:       'ကြီးမားသောဝဘ်ဆိုဒ် ငွေဖြည့်-ထုတ် ၁၀ မိနစ်အတွင်း မိနိမမ်မရှိ တာနိုဗာမရှိ ၈% ငွေပြန်',

    promo_daily_used_up:     'ယနေ့အခွင့်အရေးကုန်ပြီ',
    promo_already_used:      'ဤပရိုမိုးရှင်းသုံးပြီးပြီ',
    coupon_success_title:    'ကူပွန်သုံးပြီးပြီ',
    invalid_coupon:          'ဤ Key ကိုစနစ်တွင်မတွေ့',
    no_current_promo:        'အသုံးပြုနေသောပရိုမိုးရှင်းမရှိ',
    cancel_promo_title:      'ပရိုမိုးရှင်းဖျက်မည်?',
    cancel_promo_text:       'လက်ရှိပရိုမိုးရှင်းကို ဖျက်သိမ်းလိုသည်ဟုတ်သလား',
    cancel_promo_success:    'ပရိုမိုးရှင်းဖျက်ပြီးပြီ',
    cancel_promo_failed:     'ပရိုမိုးရှင်းဖျက်မနိုင်',
    current_promo_label:     'လက်ရှိပရိုမိုးရှင်း',
    promo_auto_on_deposit:   'ငွေဖြည့်သောအခါ ပရိုမိုးရှင်းအလိုအလျောက်ဝင်မည်',
    cancelling_label:        'ဖျက်သိမ်းနေသည်...',
    no_promo_selected:       'ပရိုမိုးရှင်းမရွေးရသေးဘူး',
    select_promo_below:      'အောက်မှ ပရိုမိုးရှင်းရွေးနိုင်သည်',
    terms_conditions:        'သဘောတူညီချက်နှင့် အခြေအနေ',
    promo_not_active:        'ပရိုမိုးရှင်းမဖွင့်ရသေးဘူး',

    cards_used_today:        'ယနေ့ ဖဲဖွင့်မှုပြည့်ပြီ နောက်ရက်ကိုစောင့်ပါ',
    not_enough_points_game:  'ဂိမ်းကစားရန် မှတ်မလုံလောက်',
    login_first_play:        'ကစားရန် ဦးစွာဝင်ရောက်ပါ',
    select_activity_first:   'ကစားမမီ ဦးစွာလှုပ်ရှားမှုရွေးပါ',
    card_reshuffle_title:    'ဖဲများကို ပြန်ဖြန်ဝေမည်',
    card_reshuffle_text:     'ပြန်ဖြန်ဝေရန် "ကောင်းပြီ" နှိပ်ပါ',
    open_card_event_title:   'ဖဲဖွင့်ပွဲကစားမည်',
    points_available_label:  'ရနိုင်သောမှတ်ပမာဏ',
    point_unit:              'မှတ်',
    enter_game_btn:          'ဝင်ကစားမည်',
    open_card_btn:           'ဖဲဖွင့်မည်',
    card_shuffled_done:      'ဖဲဖြန်ဝေပြီးပြီ',
    card_event_conditions:   'ပါဝင်ရန်အခြေအနေ',
    no_condition_found:      'ဖွင့်ရန်အခြေအနေ: မတွေ့',
    can_open_per_day:        'တစ်ရက်ကို ၂ ကြိမ်သာ ဖွင့်နိုင်သည်',
    detail_label:            'အသေးစိတ် :',
    card_history_col:        'မှတ်တမ်း',
    card_history_title:      'ဖဲဖွင့်ကစားမှတ်တမ်း',
    all_records:             'အားလုံး',
    no_records_found:        'မှတ်တမ်းမတွေ့...',
    time_col:                'အချိန်',
    amount_label_col:        'ငွေပမာဏ',

    you_have_label:          'သင်တွင်',
    needed_label:            'လိုအပ်',
    redeem_verb:             'လဲ',
    use_verb_label:          'သုံး',
    to_redeem_for_label:     'လဲလှယ်ရန်',
    today_text:              'ယနေ့',
    this_week_text:          'ဤအပတ်',

    cashback_success_notify: 'ငွေရယူမှုအောင်မြင်ပြီ',
    cashback_no_balance:     'ငွေပမာဏမရှိ၍ မလုပ်နိုင်',
    cashback_failed:         'မလုပ်နိုင်',
    not_logged_in:           'ဝင်မထားရသေးဘူး',

    process_success:         'လုပ်ဆောင်မှုပြီးပြီ',
    deposit_max_label:       'ဘတ် အများဆုံး',
    bonus_label:             'ဘောနပ်',
  },

  lo: {
    confirm:        'ຢືນຢັນ',
    cancel:         'ຍົກເລີກ',
    save:           'ບັນທຶກ',
    back:           'ກັບ',
    close:          'ປິດ',
    copy:           'ສຳເນົາ',
    copied:         'ສຳເນົາແລ້ວ!',
    loading:        'ກຳລັງໂຫລດ...',
    error:          'ເກີດຂໍ້ຜິດພາດ',
    success:        'ສຳເລັດ',
    submit:         'ສົ່ງ',
    or:             'ຫຼື',
    contact:        'ຕິດຕໍ່',
    baht:           'ບາດ',
    ok:             'ຕົກລົງ',
    search:         'ຄົ້ນຫາ',
    more:           'ເບິ່ງເພີ່ມ',
    no_data:        'ບໍ່ມີຂໍ້ມູນ',

    home:           'ໜ້າຫຼັກ',
    deposit:        'ຝາກເງິນ',
    withdraw:       'ຖອນເງິນ',
    history:        'ປະຫວັດ',
    promotion:      'ໂປໂມຊັ່ນ',
    affiliate:      'ແນະນຳໝູ່',
    cashback:       'ຄືນຍອດເສຍ',
    toprank:        'ອັນດັບ',
    redeem_reward:  'ແລກຂອງລາງວັນ',
    rebate:         'ຄືນຍອດພະນັນ',
    profile:        'ຂໍ້ມູນສ່ວນຕົວ',
    logout:         'ອອກຈາກລະບົບ',
    login:          'ເຂົ້າສູ່ລະບົບ',
    register:       'ສະໝັກສະມາຊິກ',
    lucky_fortune:  'ລໍ້ໂຊກ',
    check_in:       'ເຊັກອິນປະຈຳວັນ',
    event:          'ກິດຈະກຳ',
    casino:         'ຄາສິໂນ',
    slot:           'ສລ໋ອດ',
    fishing:        'ຍິງປາ',
    sport:          'ກີລາ',
    lotto:          'ຫວຍ',
    card_game:      'ເກມໄພ',

    menu_home:      'ໜ້າຫຼັກ',
    menu_deposit:   'ຝາກ',
    menu_contact:   'ຕິດຕໍ່',
    menu_promotion: 'ໂປ',
    menu_profile:   'ບັນຊີ',

    login_title:      'ເຂົ້າສູ່ລະບົບ',
    login_phone:      'ເຂົ້າດ້ວຍເບີໂທ',
    username_label:   'ເບີໂທລະສັບ',
    password_label:   'ລະຫັດຜ່ານ',
    forgot_password:  'ລືມລະຫັດຜ່ານ',
    no_account:       'ຍັງບໍ່ມີບັນຊີ?',
    register_now:     'ສະໝັກສະມາຊິກ',
    login_btn:        'ເຂົ້າສູ່ລະບົບ',

    register_title:     'ສະໝັກສະມາຊິກ',
    firstname:          'ຊື່-ນາມສະກຸນ',
    phone_number:       'ເບີໂທລະສັບ',
    confirm_password:   'ຢືນຢັນລະຫັດຜ່ານ',
    invite_code:        'ລະຫັດແນະນຳ (ຖ້າມີ)',
    have_account:       'ມີບັນຊີຢູ່ແລ້ວ?',
    login_now:          'ເຂົ້າສູ່ລະບົບ',
    select_bank:        'ເລືອກທະນາຄານ',
    account_number_label: 'ເລກບັນຊີທະນາຄານ',
    register_btn:       'ສະໝັກສະມາຊິກ',

    deposit_title:      'ຝາກເງິນ',
    bank_tab:           'ທະນາຄານ',
    truemoney_tab:      'ທຣູມັນນີ',
    payment_tab:        'ຊຳລະເງິນ',
    upload_slip_tab:    'ອັບໂຫລດສ້ລິບ',
    account_name:       'ຊື່ບັນຊີ',
    bank_name:          'ທະນາຄານ',
    min_amount:         'ຕ່ຳສຸດ',
    max_amount:         'ສູງສຸດ',
    amount_label:       'ຈຳນວນເງິນ (ບາດ)',
    amount_placeholder: 'ໃສ່ຈຳນວນເງິນ',
    quick_fill:         'ໃສ່ດ່ວນ',
    scan_qr:            'ສະແກນ QR Code ຊຳລະ',
    upload_slip:        'ອັບໂຫລດສ້ລິບ',
    drag_drop_text:     'ລາກຮູບມາວາງ ຫຼື ຄລິກເລືອກໄຟລ໌',
    select_file:        'ເລືອກໄຟລ໌',
    conditions_title:   'ເງື່ອນໄຂການຝາກ',
    confirm_deposit:    'ຢືນຢັນຝາກ',
    copy_account:       'ສຳເນົາ',
    deposit_to:         'ໂອນໄປທີ',
    upload_success:     'ອັບໂຫລດສຳເລັດ!',
    upload_success_desc:'ສ້ລິບຂອງທ່ານຖືກສົ່ງແລ້ວ',
    supported_format:   'ຮອງຮັບ JPG, PNG, WEBP ຂະໜາດບໍ່ເກີນ 5MB',
    change_slip:        'ປ່ຽນຮູບ',
    create_qr:          'ສ້າງ QR Code ຊຳລະ',
    confirm_payment:    'ຢືນຢັນຊຳລະ',
    promptpay_only:     'PromptPay / ທະນາຄານເທົ່ານັ້ນ',
    confirm_upload:     'ຢືນຢັນອັບໂຫລດ',
    uploading:          'ກຳລັງອັບໂຫລດ...',
    upload_slip_title:  'ອັບໂຫລດສ້ລິບ',
    upload_slip_desc:   'ແນບຫຼັກຖານການໂອນ',
    upload_success_title: 'ອັບໂຫລດສ້ລິບສຳເລັດ',
    processing:         'ລະບົບກຳລັງກວດ ກະລຸນາລໍ',
    reupload:           'ອັບໂຫລດໃໝ່',
    upload_conditions_title: 'ເງື່ອນໄຂອັບໂຫລດສ້ລິບ',
    tap_select_image:   'ແຕະເລືອກຮູບສ້ລິບ',
    go_promotion:       'ໄປໜ້າໂປໂມຊັ່ນ',

    crypto_tab:         'ຄຣິບໂຕ',
    crypto_currency:    'ສະກຸນເງິນ',
    crypto_network:     'ເຄືອຂ່າຍ',
    crypto_address:     'ທີ່ຢູ່ກະເປົ໋າ',
    crypto_scan_qr:     'ສະແກນ QR ໂອນ',
    crypto_copy:        'ສຳເນົາທີ່ຢູ່',
    crypto_upload_slip: 'ແນບຫຼັກຖານໂອນ',
    crypto_note:        'ໝາຍເຫດ: ໂອນໃຫ້ຖືກສະກຸນ ຖ້າບໍ່ດັ່ງນັ້ນເງິນສູນ',
    crypto_rate_note:   'ອັດຕາແລກປ່ຽນ ณ ເວລາທຳລາຍການ',
    crypto_confirm:     'ຢືນຢັນໂອນ',

    withdraw_title:    'ຖອນເງິນ',
    withdraw_amount:   'ຈຳນວນທີ່ຕ້ອງຖອນ',
    select_amount:     'ເລືອກຈຳນວນ',
    withdraw_to:       'ຖອນໄປທີ່ບັນຊີ',
    withdraw_min:      'ຖອນຕ່ຳສຸດ',
    withdraw_max:      'ຖອນສູງສຸດ',
    available_balance: 'ຍອດເຫຼືອ',
    confirm_withdraw:  'ຢືນຢັນຖອນ',

    profile_title:    'ຂໍ້ມູນສ່ວນຕົວ',
    account_info:     'ຂໍ້ມູນບັນຊີ',
    fullname:         'ຊື່-ນາມສະກຸນ',
    rank:             'ລະດັບ',
    credit:           'ເຄຣດິດ',
    point:            'ຄະແນນ',
    change_password:  'ປ່ຽນລະຫັດ',
    old_password:     'ລະຫັດເກົ່າ',
    new_password:     'ລະຫັດໃໝ່',
    account_number:   'ເລກບັນຊີ',

    history_title:   'ປະຫວັດທຸລະກຳ',
    all_type:        'ທັງໝົດ',
    deposit_type:    'ຝາກ',
    withdraw_type:   'ຖອນ',
    bonus_type:      'ໂບນັດ',
    date_col:        'ວັນທີ',
    amount_col:      'ຈຳນວນ',
    status_col:      'ສະຖານະ',
    status_approve:  'ສຳເລັດ',
    status_pending:  'ລໍຖ້າ',
    status_reject:   'ປະຕິເສດ',

    promotion_title: 'ໂປໂມຊັ່ນ',
    apply_promo:     'ຮັບໂປ',
    in_use_promo:    'ກຳລັງໃຊ້',
    promo_full:      'ເຕັມ',
    promo_available: 'ວ່າງ',
    promo_detail:    'ລາຍລະອຽດ',
    no_promotion:    'ບໍ່ມີໂປ',
    cancel_promo:    'ຍົກເລີກໂປ',
    min_deposit:     'ຝາກຕ່ຳສຸດ',
    bonus_percent:   'ໂບນັດ',
    max_withdraw:    'ຖອນສູງສຸດ',
    turn_over:       'ເທີນໂອເວີ',

    affiliate_title: 'ແນະນຳໝູ່',
    invite_link:     'ລິ້ງແນະນຳ',
    today_income:    'ລາຍຮັບມື້ນີ້',
    total_income:    'ລາຍຮັບທັງໝົດ',
    member_count:    'ຈຳນວນສະມາຊິກ',
    withdraw_btn:    'ຖອນ',
    share_line:      'ແຊຣ LINE',

    cashback_title:    'ຄືນຍອດເສຍ',
    period_label:      'ຮອບ',
    eligible_amount:   'ຍອດເສຍທີ່ໄດ້ຮັບ',
    cashback_rate:     'ອັດຕາຄືນ',
    receive_cashback:  'ຮັບຄືນ',
    cashback_history:  'ປະຫວັດຮັບ',

    rebate_title:   'ຄືນຍອດພະນັນ',
    rebate_amount:  'ຍອດພະນັນ',
    receive_rebate: 'ຮັບຄືນ',

    toprank_title: 'ອັນດັບ',
    rank_col:      'ອັນດັບ',
    username_col:  'ຊື່ຜູ້ໃຊ້',
    credit_col:    'ເຄຣດິດ',

    redeem_title:   'ແລກຂອງລາງວັນ',
    redeem_btn:     'ແລກ',
    my_points:      'ຄະແນນຂອງຂ້ອຍ',
    required_points:'ຄະແນນທີ່ຕ້ອງການ',

    spin_btn:       'ໝູນ',
    spin_free:      'ຟຣີ',
    spin_remaining: 'ເທື່ອທີ່ເຫຼືອ',
    checkin_day:    'ວັນ',
    checkin_title:  'ເຊັກອິນປະຈຳວັນ',
    checkin_btn:    'ເຊັກອິນ',
    checkin_done:   'ເຊັກອິນແລ້ວ',

    language_label:    'Language / ພາສາ',
    footer_seo_title:  'ຄາສິໂນອອນໄລນ໌ຄົບ',
    footer_desc:       'ບໍລິການຝາກ-ຖອນໂອໂຕ 24 ຊົ່ວໂມງ',

    event_title: 'ກິດຈະກຳ',

    register_phone_subtitle: 'ສະໝັກດ້ວຍເບີໂທ',
    referrer:                'ຜູ້ແນະນຳ',
    next:                    'ຕໍ່ໄປ',
    password_step:           'ລະຫັດຜ່ານ',
    select_bank_title:       'ກະລຸນາເລືອກທະນາຄານ',
    account_no_placeholder:  'ເລກບັນຊີ',
    account_name_placeholder:'ຊື່ບັນຊີ',
    contact_btn:             'ຕິດຕໍ່',

    checkin_activity_title:        'ກິດຈະກຳເຊັກອິນ',
    checkin_subtitle:              'ຮັບທຸກວັນ ພຽງເຂົ້າເຊັກອິນ ສະສົມຮັບລາງວັນ',
    checkin_min_deposit_prefix:    'ເຕີມຍອດ',
    checkin_min_deposit_suffix:    '.- ຂຶ້ນໄປ',
    today:                         'ມື້ນີ້',
    checkin_monthly:               'ເຊັກອິນສະສົມເດືອນນີ້',
    max_label:                     'ສູງສຸດ',
    day_unit:                      'ວັນ',

    my_points_label:    'ຄະແນນຂອງທ່ານ',
    reward_items_tab:   'ຂອງລາງວັນ',
    redeem_history_tab: 'ປະຫວັດແລກ',
    no_rewards_yet:     'ຍັງບໍ່ມີຂອງລາງວັນ',
    no_redeem_history:  'ຍັງບໍ່ມີປະຫວັດ',
    stock_remaining:    'ເຫຼືອ',
    out_of_stock:       'ໝົດ',
    redeem_now:         'ແລກເລີຍ',
    not_enough_points:  'ຄະແນນບໍ່ພໍ',

    lucky_wheel_title:          'ລໍ້ໂຊກ',
    spin_wheel_btn:             'ໝູນລໍ້',
    lucky_wheel_alt:            'ລໍ້ໂຊກ ລໍ້ມະຫາສະໜຸກ',
    invite_success:             'ຮັບເງິນສຳເລັດ',
    invite_no_balance:          'ບໍ່ສາມາດ ບໍ່ມີຍອດ',
    action_failed:              'ທຳລາຍການບໍ່ໄດ້',
    wheel_conditions_title:     'ເງື່ອນໄຂການໃຫ້ບໍລິການ',
    wheel_cond_deposit:         '• ຝາກສະສົມຄົບ 1,000 ບາດ ໄດ້ 1 ຕ໋ວ (ສູງສຸດ 5 ຕ໋ວ/ວັນ)',
    wheel_cond_reset_prefix:    '• ຍອດຝາກສະສົມຈະ',
    wheel_cond_reset_value:     'ລີເຊັດເປັນ 0',
    wheel_cond_reset_suffix:    'ທຸກວັນ 00:00',
    wheel_cond_ticket_note:     '*ຕ໋ວລໍ້ຄຳນວນເມື່ອເຂົ້າໜ້ານີ້ເທົ່ານັ້ນ',
    wheel_cond_no_entry:        'ບໍ່ເຂົ້າ ບໍ່ໄດ້ຮັບ',

    popular:          'ຍອດນິຍົມ',
    esport:           'ອີສປ໋ອດ',
    slots_popular:    'ສລ໋ອດຍອດນິຍົມ',
    casino_popular:   'ຄາສິໂນຍອດນິຍົມ',
    lucky_wheel_short:'ລໍ້',
    open_card:        'ເປີດໄພ',
    open_card_event:  'ກິດຈະກຳເປີດໄພ',
    checkin_short:    'ເຊັກອິນ',
    loss_cashback:    'ຮັບຍອດເສຍ',
    loss_short:       'ຍອດເສຍ',
    deposit_problem:  'ຖ້າເກີດບັນຫາ ກະລຸນາຕິດຕໍ່ພະນັກງານ',

    trading:          'ການຄ້າ',
    play_btn:         'ເຂົ້າຫຼິ້ນ',
    not_open_yet:     'ຍັງບໍ່ເປີດ',
    play_game:        'ຫຼິ້ນເກມ',

    your_account:       'ບັນຊີຂອງທ່ານ',
    transfer_note_only: 'ໂອນດ້ວຍບັນຊີທີ່ລະບົບແຈ້ງເທົ່ານັ້ນ',
    bank_dest:          'ທະນາຄານປາຍທາງ',
    savings_type:       'ອອມຊັບ',
    acc_no_label:       'ເລກບັນຊີ',
    copy_acc_no:        'ສຳເນົາເລກບັນຊີ',
    notify_transfer_done: 'ແຈ້ງໂອນສຳເລັດ',
    notify_transfer:    'ແຈ້ງໂອນ',
    transfer_warning:   'ແຈ້ງໂອນພາຍໃນ 5 ນາທີ',
    uploading_slip:     'ກຳລັງອັບໂຫລດ...',
    confirm_upload_btn: 'ຢືນຢັນອັບໂຫລດ',
    payment_channel:    'ຊ່ອງທາງຊຳລະ',
    wallet_type:        'ກະເປົ໋າ',
    wallet_number_label:'ເລກກະເປົ໋າ',
    copy_wallet_no:     'ສຳເນົາເລກກະເປົ໋າ',
    truemoney_warning:  'ໂອນຈາກ TrueMoney ໄປຫາເບີຂ້າງເທິງ ແຈ້ງ LINE Admin ລະບົບເຕີມ 5 ນາທີ',

    cond_pay_1: 'ກົດຢືນຢັນ ຊຳລະພາຍໃນເວລາ',
    cond_pay_2: 'ຊຳລະແລ້ວ ເຄຣດິດບໍ່ເຂົ້າ ຕິດຕໍ່ Admin',
    cond_pay_3: 'ຢ່າກົດຢືນຢັນຊ້ຳ',
    cond_slip_1:'ອັບໂຫລດຫຼັງໂອນ',
    cond_slip_2:'ຮູບຊັດ ເຫັນຈຳນວນ-ເວລາ',
    cond_slip_3:'ຢ່າອັບໂຫລດຊ້ຳ ຫຼື ສ້ລິບປອມ',

    qr_for_payment:      'QR Code ຊຳລະ',
    scan_once_only:      'ສະແກນຄັ້ງດຽວ ຢ່າຊ້ຳ',
    pay_within_time:     'ຊຳລະພາຍໃນເວລາ',
    cancel_transaction:  'ຍົກເລີກລາຍການ',
    new_transaction:     'ທຳລາຍການໃໝ່',
    payment_via_system:  'ຊຳລະຜ່ານ Payment',
    min_deposit_note:    'ຕ່ຳສຸດ {min} ບາດ ສູງສຸດ {max} ບາດ',
    cond_slip_4:         'ລະບົບກວດ ເຕີມ 5 ນາທີ',
    cond_slip_5:         'ບັນຫາ ຕິດຕໍ່ Admin Line',
    confirm_transfer:    'ຢືນຢັນໂອນ',
    crypto_warning_net:  'ໂອນໃຫ້ຖືກສະກຸນ-ເຄືອຂ່າຍ ຖ້າບໍ່ດັ່ງນັ້ນສູນ',
    exchange_rate_note:  'ອັດຕາ ณ ເວລາທຳລາຍການ',
    game_balance:        'ຍອດໃນເກມ',
    mission_label:       'ພາລະກິດ',
    sec_unit:            'ວິນາທີ',
    notify_slip_warning: 'ແຈ້ງໂອນ 5 ນາທີ ລະບົບຍົກເລີກອັດຕະໂນມັດ',

    crypto_title_short:  'ຄຣິບໂຕ',
    crypto_send_note:    'ໂອນໄປທີ່ຢູ່ຂ້າງລຸ່ມ',
    select_currency:     'ເລືອກສະກຸນ',
    wallet_address_label:'ທີ່ຢູ່ກະເປົ໋າ',
    min_label_short:     'ຕ່ຳສຸດ',
    max_label_short:     'ສູງສຸດ',
    attach_proof:        'ແນບຫຼັກຖານ',
    drag_or_click:       'ລາກ ຫຼື ຄລິກ',
    click_to_change:     'ຄລິກປ່ຽນ',

    not_logged_in:           'ຍັງບໍ່ໄດ້ເຂົ້າ',
    not_logged_in_text:      'ທ່ານຍັງບໍ່ໄດ້ລ໋ອກອິນ',
    select_slip_file:        'ເລືອກໄຟລ໌ສ້ລິບ',
    upload_slip_failed:      'ອັບໂຫລດບໍ່ສຳເລັດ',
    transaction_done:        'ດຳເນີນສຳເລັດ',
    transaction_failed:      'ທຳລາຍການບໍ່ສຳເລັດ',
    error_occurred:          'ເກີດຂໍ້ຜິດພາດ',
    session_expired:         'Session ໝົດ ລ໋ອກອິນໃໝ່',
    game_problem:            'ເກມມີບັນຫາ ລໍ',
    qr_scan_5min:            'ສະແກນ QR 5 ນາທີ',
    force_withdraw_all:      'ຖອນທັງໝົດ',
    insufficient_withdraw:   'ຍອດຖອນບໍ່ພໍ',
    withdraw_success:        'ຖອນສຳເລັດ',
    turnover_remaining_prefix: 'Turnover ຄ້າງ',
    min_withdraw_prefix:     'ຖອນຕ່ຳສຸດ',
    withdraw_error:          'ຖອນບໍ່ໄດ້ ຕິດຕໍ່ພະນັກງານ',
    withdraw_problem:        'ຖອນມີບັນຫາ ຕິດຕໍ່ພະນັກງານ',
    change_password_success: 'ປ່ຽນລະຫັດສຳເລັດ',
    wrong_old_password:      'ລະຫັດເກົ່າຜິດ',
    password_error:          'ຜິດພາດ ລອງໃໝ່',
    same_password:           'ລະຫັດໃໝ່ຊ້ຳເກົ່າ',
    password_mismatch:       'ລະຫັດບໍ່ຕົງ',
    copy_success:            'ສຳເນົາສຳເລັດ',
    select_file_first:       'ເລືອກໄຟລ໌ກ່ອນ',
    time_expired:            'ໝົດເວລາ',
    hour_unit:               'ຊົ່ວໂມງ',

    truegift_tab:            'ຂອງຂວັນ TrueMoney',
    no_bank_account:         'ບໍ່ພົບບັນຊີ',
    copy_acc_done:           'ສຳເນົາເລກບັນຊີແລ້ວ!',
    copy_acc_prefix:         'ສຳເນົາເລກບັນຊີ',
    select_deposit_amount:   'ເລືອກຈຳນວນຝາກ',
    enter_amount:            'ລະບຸຈຳນວນ',
    bank_transfer_warning:   'ໂອນດ້ວຍບັນຊີທີ່ລົງທະບຽນ ຖ້າບໍ່ ແຈ້ງ LINE Admin',
    no_autoslip:             'ບໍ່ພົບ AutoSlip',
    upload_slip_auto_label:  'ອັບໂຫລດສ້ລິບ (ກວດໂອໂຕ)',
    confirm_upload_slip:     'ຢືນຢັນອັບໂຫລດ',
    upload_success_checking: 'ອັບໂຫລດສຳເລັດ! ກຳລັງກວດ...',
    transfer_warning_short:  'ໂອນດ້ວຍບັນຊີທີ່ລົງທະບຽນ',
    no_truewallet:           'ບໍ່ພົບ TrueMoney',
    truemoney_phone_label:   'ເບີ TrueMoney ຂອງທ່ານ',
    submitting:              'ກຳລັງສົ່ງ...',
    notify_truemoney_deposit:'ແຈ້ງຝາກ TrueMoney',
    truemoney_submit_success:'ແຈ້ງ TrueMoney ສຳເລັດ ລໍ',
    deposit_gift_truemoney:  'ຝາກດ້ວຍ Gift TrueMoney',
    gift_paste_hint:         'ວາງລິ້ງ Gift ຈາກ gift.truemoney.com ສົ່ງ',
    gift_link_label:         'ລິ້ງ Gift TrueMoney',
    checking:                'ກຳລັງກວດ...',
    send_gift_link:          'ສົ່ງລິ້ງ',
    gift_submit_success:     'ສົ່ງລິ້ງສຳເລັດ ລໍ',
    no_payment_gateway:      'ບໍ່ພົບ Gateway',
    pay_via_gateway:         'ຊຳລະຜ່ານ Gateway',
    contact_admin:           'ຕິດຕໍ່ Admin',
    no_crypto:               'ບໍ່ພົບກະເປົ໋າຄຣິບໂຕ',
    crypto_thb_label:        'ໃສ່ຈຳນວນ (ບາດ)',
    crypto_amount_prefix:    'ຈຳນວນ',
    crypto_amount_suffix:    'ທີ່ຕ້ອງໂອນ',
    crypto_send_only:        'ສົ່ງສະເພາະ',
    crypto_send_only_suffix: 'ເທົ່ານັ້ນ',
    crypto_wrong_type_warning:'ສົ່ງຜິດ ສູນສິນຊັບ',
    load_failed_retry:       'ໂຫລດບໍ່ໄດ້ ລອງໃໝ່',

    from_last_month:         'ຈາກເດືອນກ່ອນ',
    withdrawable_income:     'ລາຍຮັບຖອນໄດ້',
    members_this_month:      'ສະມາຊິກເດືອນນີ້',
    new_members_today:       'ສະມາຊິກໃໝ່ມື້ນີ້',
    person_unit:             'ຄົນ',
    how_to_build_network:    'ວິທີສ້າງເຄືອຂ່າຍ',
    seven_days_filter:       '7 ວັນ',
    month_filter:            'ເດືອນ',
    new_member_tab:          'ສະມາຊິກໃໝ່',
    history_all_tab:         'ປະຫວັດ/ທັງໝົດ',
    active_total:            'ຍອດ Active',
    this_month:              'ເດືອນນີ້',
    all_members:             'ສະມາຊິກທັງໝົດ',
    total_referred:          'ແນະນຳທັງໝົດ',
    deposited_badge:         'ເຕີມແລ້ວ',
    not_deposited_badge:     'ຍັງບໍ່ເຕີມ',
    income_summary_all:      'ສະຫຼຸບລາຍຮັບ',
    network_income_total:    'ລາຍຮັບຈາກເຄືອຂ່າຍ',
    income_this_month:       'ລາຍຮັບເດືອນນີ້',
    income_last_month:       'ລາຍຮັບເດືອນກ່ອນ',
    aff_easy_rich_tagline:   'ຮັ່ງມີງ່າຍ ກັບ Salmon',
    aff_share_link_tagline:  'ແຊຣລິ້ງ ໄດ້ລາຍຮັບ',
    aff_step1:               'ສຳເນົາລິ້ງ',
    aff_step2:               'ແຊຣ Line ຫຼື Social',
    aff_step3:               'ໝູ່ສະໝັກ ເຕີມ',
    aff_step4:               'ຮັບລາຍຮັບທັນທີ',
    your_link:               'ລິ້ງຂອງທ່ານ',
    aff_tab_overview:        'ພາບລວມ',
    aff_tab_members:         'ສະມາຊິກ',
    aff_tab_income:          'ສະຫຼຸບ',
    aff_tab_network:         'ເຄືອຂ່າຍ',
    aff_claim_success:       'ຮັບເງິນສຳເລັດ',
    aff_no_balance:          'ບໍ່ມີຍອດ',
    aff_claim_failed:        'ທຳບໍ່ໄດ້',
    user_label:              'ຍູເຊີ',

    footer_site_heading:     'ຄາສິໂນ ສລ໋ອດ ບາຄາຣ່າ ຍິງປາ ກີລາ ຄົບ',
    footer_p1:               'ຫຼິ້ນ 10 ບາດ ຝາກ-ຖອນ 24 ຊົ່ວໂມງ ໂອໂຕ',
    footer_service_heading:  '24 ຊົ່ວໂມງ 7 ວັນ ບໍລິການດີ',
    footer_p2_part1:         'ທີມລູກຄ້າ 24 ຊົ່ວໂມງ',
    footer_p2_part2:         'WM Casino, Dream Gaming, ALLBET, Joker, PG Slot ແລະ ອື່ນໆ',
    footer_p3:               'ຄາສິໂນຄົບ ຖ່າຍທອດສົດ 24 ຊົ່ວໂມງ',
    footer_casino_online:    'ຄາສິໂນອອນໄລນ໌',
    footer_baccarat_tagline: 'ບາຄາຣ່າ ດີທີ່ສຸດ',

    cancel_promo_confirm:    'ຍົກເລີກໂປບໍ?',
    action_failed_wait:      'ບໍ່ໄດ້ ລໍ',
    promo_not_eligible:      'ບໍ່ຜ່ານເງື່ອນໄຂ',
    promo_pending_deposit:   'ໂປຄ້າງ ເຕີມໄດ້',

    promo_join_title:        'ເຂົ້າຮ່ວມໂປ',
    no_transaction_text:     'ຍັງບໍ່ມີລາຍການ',
    status_label:            'ສະຖານະ :',
    status_cancel_player:    'ຍົກເລີກ (ຜູ້ຫຼິ້ນ)',
    status_cancel_player_short: 'ຍົກເລີກ (ຜູ້ຫຼິ້ນ)',
    status_failed_system:    'ບໍ່ສຳເລັດ (ລະບົບ)',
    time_unit:               'ໂມງ',

    login_redirecting:       'ເຂົ້າ ກຳລັງໄປ',
    invalid_credentials:     'ຊື່ ຫຼື ລະຫັດຜິດ',
    contact_problem_title:   'ພົບບັນຫາ',
    contact_support_text:    'ຕິດຕໍ່ຝ່າຍບໍລິການ',
    phone_invalid:           'ເບີຜິດ',
    phone_in_use:            'ເບີໃຊ້ຢູ່ແລ້ວ',
    rate_limited:            'ຖີ່ເກີນ ລໍ',
    fill_bank_info:          'ເລືອກທະນາຄານ ໃສ່ຂໍ້ມູນ',
    incomplete_digits:       'ຕົວເລກບໍ່ຄົບ',
    otp_invalid:             'ລະຫັດຜິດ',
    no_account_number:       'ບໍ່ໃສ່ເລກບັນຊີ',
    no_bank_selected:        'ຍັງບໍ່ເລືອກທະນາຄານ',
    invalid_account_number:  'ເລກບັນຊີຜິດ',
    register_success:        'ສະໝັກສຳເລັດ ລໍ',
    account_already_registered: 'ເລກບັນຊີລົງທະບຽນແລ້ວ',
    username_already_taken:  'Username ນີ້ລົງທະບຽນແລ້ວ',
    invalid_username_name:   'Username ຫຼື ຊື່ຜິດ',
    no_fullname:             'ບໍ່ໃສ່ຊື່',
    password_max_15:         'ລະຫັດສູງສຸດ 15',
    password_min_4:          'ລະຫັດຕ່ຳສຸດ 4',
    confirm_password_mismatch: 'ລະຫັດບໍ່ຕົງ',

    rank_claim_confirm:      'Claim Rank ບໍ?',
    current_deposit:         'ຍອດຝາກປັດຈຸບັນ',
    need_deposit:            'ຕ້ອງຝາກ',
    not_qualified:           'ຍັງບໍ່ຜ່ານ',
    processing_label:        'ກຳລັງດຳເນີນ...',
    deposit_baht_up:         'ບາດຂຶ້ນໄປ',
    deposit_limit_prefix:    'ຝາກຕ່ຳສຸດ',

    loss_calculated_title:   'ຍອດເສຍທີ່ຄຳນວນ',
    daily_type:              'ລາຍວັນ',
    weekly_type:             'ລາຍອາທິດ',
    monthly_type:            'ລາຍເດືອນ',
    next_round_prefix:       'ຮອບຕໍ່ໄປ:',
    total_receivable_cashback: 'ຍອດຄືນທັງໝົດ',
    withdrawable_cashback:   'ຍອດຄືນຖອນໄດ້',

    coming_soon:             'ໄວໆນີ້',
    toprank_subtitle:        'ອັບເດດລ່າສຸດ · ຊະນະສູງສຸດ',

    checkin_success_title:   'ເຊັກອິນສຳເລັດ',
    checkin_failed_title:    'ເຊັກອິນບໍ່ສຳເລັດ',
    checkin_error_title:     'ເຊັກອິນບໍ່ໄດ້',
    checkin_date_wrong:      'ວັນບໍ່ຕົງ',
    claim_reward_success:    'ຮັບລາງວັນສຳເລັດ',
    claim_reward_failed:     'ຮັບລາງວັນບໍ່ສຳເລັດ',
    checkin_error_msg:       'ຜິດໃນການເຊັກອິນ',
    try_again:               'ລອງໃໝ່',

    login_first_title:       'ເຂົ້າກ່ອນ',
    login_first_text:        'ເຂົ້າກ່ອນ ຈຶ່ງຈະແລກໄດ້',
    not_enough_points_title: 'ຄະແນນບໍ່ພໍ',
    redeem_success_title:    'ແລກສຳເລັດ!',
    redeem_success_text:     'ລາຍການຂອງທ່ານຖືກບັນທຶກ',
    failed_title:            'ບໍ່ສຳເລັດ',

    announcement_label:      'ປະກາດ',
    hide_today:              'ບໍ່ສະແດງມື້ນີ້',

    textslide_default:       'ເວັບໃຫຍ່ ຝາກ-ຖອນ ໂອໂຕ ຄ່ຳ 10 ວິ ຄືນ 8%',

    promo_daily_used_up:     'ໃຊ້ສິດຄົບ',
    promo_already_used:      'ໃຊ້ໂປນີ້ແລ້ວ',
    coupon_success_title:    'ໃຊ້ຄູປ໋ອງສຳເລັດ',
    invalid_coupon:          'ບໍ່ພົບ Key',
    no_current_promo:        'ບໍ່ມີໂປທີ່ໃຊ້',
    cancel_promo_title:      'ຍົກເລີກໂປ?',
    cancel_promo_text:       'ຍົກເລີກໂປປັດຈຸບັນ',
    cancel_promo_success:    'ຍົກເລີກສຳເລັດ',
    cancel_promo_failed:     'ຍົກເລີກບໍ່ໄດ້',
    current_promo_label:     'ໂປປັດຈຸບັນ',
    promo_auto_on_deposit:   'ໂປເຂົ້າໂອໂຕ',
    cancelling_label:        'ກຳລັງຍົກເລີກ...',
    no_promo_selected:       'ບໍ່ໄດ້ຮັບໂປ',
    select_promo_below:      'ເລືອກໂປລຸ່ມ',
    terms_conditions:        'ຂໍ້ຕົກລົງ ແລ້ວ ເງື່ອນໄຂ',
    promo_not_active:        'ໂປຍັງບໍ່ເປີດ',

    cards_used_today:        'ເປີດໄພຄົບ ລໍ',
    not_enough_points_game:  'ຄະແນນບໍ່ພໍ',
    login_first_play:        'ເຂົ້າກ່ອນ',
    select_activity_first:   'ເລືອກກິດຈະກຳກ່ອນ',
    card_reshuffle_title:    'ຈະ reset ໄພ',
    card_reshuffle_text:     'ກົດ "ຕົກລົງ" ສຸ່ມໃໝ່',
    open_card_event_title:   'ກິດຈະກຳເປີດໄພ',
    points_available_label:  'ຄະແນນທີ່ໃຊ້ໄດ້',
    point_unit:              'ຄະແນນ',
    enter_game_btn:          'ເຂົ້າຫຼິ້ນ',
    open_card_btn:           'ເປີດໄພ',
    card_shuffled_done:      'ສຸ່ມສຳເລັດ',
    card_event_conditions:   'ເງື່ອນໄຂ',
    no_condition_found:      'ເງື່ອນໄຂ: ບໍ່ພົບ',
    can_open_per_day:        '2 ຄັ້ງ/ວັນ',
    detail_label:            'ລາຍລະອຽດ :',
    card_history_col:        'ປະຫວັດ',
    card_history_title:      'ປະຫວັດເປີດໄພ',
    all_records:             'ທັງໝົດ',
    no_records_found:        'ບໍ່ພົບລາຍການ...',
    time_col:                'ເວລາ',
    amount_label_col:        'ຈຳນວນ',

    you_have_label:          'ທ່ານມີ',
    needed_label:            'ຕ້ອງການ',
    redeem_verb:             'ແລກ',
    use_verb_label:          'ໃຊ້',
    to_redeem_for_label:     'ເພື່ອແລກ',
    today_text:              'ມື້ນີ້',
    this_week_text:          'ອາທິດນີ້',

    cashback_success_notify: 'ຮັບເງິນສຳເລັດ',
    cashback_no_balance:     'ບໍ່ມີຍອດ',
    cashback_failed:         'ທຳບໍ່ໄດ້',
    not_logged_in:           'ຍັງບໍ່ໄດ້ເຂົ້າ',

    process_success:         'ດຳເນີນສຳເລັດ',
    deposit_max_label:       'ບາດ ສູງສຸດ',
    bonus_label:             'ໂບນັດ',
  },
};

/**
 * Translate a key for the given language.
 * Falls back to Thai if key not found in target language.
 * Falls back to key string itself if not found in Thai either.
 *
 * @param {string} lang  - 'th' | 'en' | 'zh' | 'ja'
 * @param {string} key   - translation key
 * @returns {string}
 */
// ── Login / Register (v3) supplementary keys, all 6 languages ──
const _authExt = {
  th: {
    ln_user_title: 'กรอก Username หรือเบอร์โทรศัพท์', ln_user_sub: 'ใช้ Username หรือเบอร์โทรศัพท์เพื่อเข้าสู่ระบบ',
    ln_pass_title: 'รหัสผ่าน', ln_pass_sub: 'กรอกรหัสเข้าระบบ', ln_next: 'ถัดไป', ln_back: 'ย้อนกลับ',
    ln_problem: 'พบปัญหา', ln_contact_cs: 'ติดต่อฝ่ายบริการลูกค้า', ln_alert: 'แจ้งเตือน',
    ln_enter_user: 'กรุณากรอก Username หรือเบอร์โทรศัพท์', ln_wrong_cred: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
    rg_phone_title: 'กรอกหมายเลขโทรศัพท์', rg_phone_sub: 'ทางระบบจะส่งรหัสยืนยัน OTP ให้ท่าน', rg_referrer_ph: 'ผู้แนะนำ (ถ้ามี)',
    rg_otp_title: 'ยืนยัน OTP', rg_otp_ph: 'กรุณากรอก OTP 4 หลัก', rg_bank_title: 'กรอกเลขที่บัญชี', rg_select_bank: 'กรุณาเลือกบัญชีธนาคารของท่าน',
    rg_verify1: 'โปรดตรวจสอบ ชื่อ และ เลขบัญชี !!', rg_verify2: 'หากไม่ถูกต้อง จะไม่สามารถแก้ไข หรือ ฝากถอนได้',
    rg_acc_ph: 'กรอกเลขบัญชี', rg_name_ph: 'กรอก ชื่อ - นามสกุล (ภาษาไทยเท่านั้น)', rg_fill_warn: 'กรอกข้อมูลให้ครบถ้วนและถูกต้องมิฉะนั้นท่านจะไม่สามารถถอนเงินได้',
    rg_pass_title: 'ตั้งรหัสผ่าน', rg_pass_sub: 'ตั้งรหัสผ่านสำหรับเข้าสู่ระบบ (อย่างน้อย 6 ตัว)', rg_pass_ph: 'รหัสผ่าน', rg_passcf_ph: 'ยืนยันรหัสผ่าน',
    rg_continue: 'ต่อไป', rg_cancel: 'ยกเลิก',
  },
  en: {
    ln_user_title: 'Enter Username or Phone', ln_user_sub: 'Use your username or phone number to log in',
    ln_pass_title: 'Password', ln_pass_sub: 'Enter your login password', ln_next: 'Next', ln_back: 'Back',
    ln_problem: 'Need help?', ln_contact_cs: 'Contact Customer Service', ln_alert: 'Notice',
    ln_enter_user: 'Please enter your username or phone number', ln_wrong_cred: 'Incorrect username or password',
    rg_phone_title: 'Enter Phone Number', rg_phone_sub: 'We will send you an OTP verification code', rg_referrer_ph: 'Referrer (optional)',
    rg_otp_title: 'Verify OTP', rg_otp_ph: 'Enter 4-digit OTP', rg_bank_title: 'Enter Account Number', rg_select_bank: 'Please select your bank account',
    rg_verify1: 'Please verify your name and account number !!', rg_verify2: 'If incorrect, it cannot be edited or used for deposit/withdrawal',
    rg_acc_ph: 'Enter account number', rg_name_ph: 'Enter full name (Thai only)', rg_fill_warn: 'Enter complete and correct details, otherwise you cannot withdraw',
    rg_pass_title: 'Set Password', rg_pass_sub: 'Set a login password (at least 6 characters)', rg_pass_ph: 'Password', rg_passcf_ph: 'Confirm Password',
    rg_continue: 'Continue', rg_cancel: 'Cancel',
  },
  zh: {
    ln_user_title: '输入用户名或手机号', ln_user_sub: '使用用户名或手机号登录',
    ln_pass_title: '密码', ln_pass_sub: '请输入登录密码', ln_next: '下一步', ln_back: '返回',
    ln_problem: '遇到问题？', ln_contact_cs: '联系客服', ln_alert: '提示',
    ln_enter_user: '请输入用户名或手机号', ln_wrong_cred: '用户名或密码错误',
    rg_phone_title: '输入手机号码', rg_phone_sub: '系统将向您发送OTP验证码', rg_referrer_ph: '推荐人（可选）',
    rg_otp_title: '验证OTP', rg_otp_ph: '请输入4位OTP', rg_bank_title: '输入银行账号', rg_select_bank: '请选择您的银行账户',
    rg_verify1: '请核对姓名和账号！！', rg_verify2: '如有错误，将无法修改或存取款',
    rg_acc_ph: '输入银行账号', rg_name_ph: '输入姓名（仅限泰文）', rg_fill_warn: '请填写完整正确的信息，否则将无法提款',
    rg_pass_title: '设置密码', rg_pass_sub: '设置登录密码（至少6位）', rg_pass_ph: '密码', rg_passcf_ph: '确认密码',
    rg_continue: '继续', rg_cancel: '取消',
  },
  ja: {
    ln_user_title: 'ユーザー名または電話番号を入力', ln_user_sub: 'ユーザー名または電話番号でログイン',
    ln_pass_title: 'パスワード', ln_pass_sub: 'ログインパスワードを入力', ln_next: '次へ', ln_back: '戻る',
    ln_problem: 'お困りですか？', ln_contact_cs: 'カスタマーサービスに連絡', ln_alert: 'お知らせ',
    ln_enter_user: 'ユーザー名または電話番号を入力してください', ln_wrong_cred: 'ユーザー名またはパスワードが正しくありません',
    rg_phone_title: '電話番号を入力', rg_phone_sub: 'OTP認証コードをお送りします', rg_referrer_ph: '紹介者（任意）',
    rg_otp_title: 'OTP認証', rg_otp_ph: '4桁のOTPを入力', rg_bank_title: '口座番号を入力', rg_select_bank: '銀行口座を選択してください',
    rg_verify1: '名前と口座番号をご確認ください！！', rg_verify2: '誤りがある場合、修正や入出金ができません',
    rg_acc_ph: '口座番号を入力', rg_name_ph: '氏名を入力（タイ語のみ）', rg_fill_warn: '正確な情報を入力してください。さもないと出金できません',
    rg_pass_title: 'パスワード設定', rg_pass_sub: 'ログイン用パスワードを設定（6文字以上）', rg_pass_ph: 'パスワード', rg_passcf_ph: 'パスワード確認',
    rg_continue: '次へ', rg_cancel: 'キャンセル',
  },
  my: {
    ln_user_title: 'အသုံးပြုသူအမည် သို့မဟုတ် ဖုန်းနံပါတ်ထည့်ပါ', ln_user_sub: 'အကောင့်ဝင်ရန် အသုံးပြုသူအမည် သို့မဟုတ် ဖုန်းနံပါတ်သုံးပါ',
    ln_pass_title: 'စကားဝှက်', ln_pass_sub: 'အကောင့်ဝင်စကားဝှက်ထည့်ပါ', ln_next: 'ရှေ့ဆက်ရန်', ln_back: 'နောက်သို့',
    ln_problem: 'အကူအညီလိုပါသလား？', ln_contact_cs: 'ဖောက်သည်ဝန်ဆောင်မှုသို့ဆက်သွယ်ပါ', ln_alert: 'အသိပေးချက်',
    ln_enter_user: 'အသုံးပြုသူအမည် သို့မဟုတ် ဖုန်းနံပါတ်ထည့်ပါ', ln_wrong_cred: 'အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက်မှားနေပါသည်',
    rg_phone_title: 'ဖုန်းနံပါတ်ထည့်ပါ', rg_phone_sub: 'OTP အတည်ပြုကုဒ်ပို့ပေးပါမည်', rg_referrer_ph: 'မိတ်ဆက်သူ (ရွေးချယ်နိုင်)',
    rg_otp_title: 'OTP အတည်ပြုပါ', rg_otp_ph: 'OTP ၄ လုံးထည့်ပါ', rg_bank_title: 'အကောင့်နံပါတ်ထည့်ပါ', rg_select_bank: 'သင့်ဘဏ်အကောင့်ရွေးပါ',
    rg_verify1: 'အမည်နှင့်အကောင့်နံပါတ်စစ်ဆေးပါ !!', rg_verify2: 'မမှန်ပါက ပြင်ဆင်၍မရ၊ ငွေသွင်းထုတ်၍မရပါ',
    rg_acc_ph: 'အကောင့်နံပါတ်ထည့်ပါ', rg_name_ph: 'အမည်အပြည့်အစုံထည့်ပါ (ထိုင်းစာသာ)', rg_fill_warn: 'အချက်အလက်ပြည့်စုံမှန်ကန်စွာဖြည့်ပါ၊ မဟုတ်ပါက ငွေထုတ်၍မရပါ',
    rg_pass_title: 'စကားဝှက်သတ်မှတ်ပါ', rg_pass_sub: 'အကောင့်ဝင်စကားဝှက်သတ်မှတ်ပါ (အနည်းဆုံး ၆ လုံး)', rg_pass_ph: 'စကားဝှက်', rg_passcf_ph: 'စကားဝှက်အတည်ပြုပါ',
    rg_continue: 'ရှေ့ဆက်ရန်', rg_cancel: 'ပယ်ဖျက်',
  },
  lo: {
    ln_user_title: 'ປ້ອນຊື່ຜູ້ໃຊ້ ຫຼື ເບີໂທ', ln_user_sub: 'ໃຊ້ຊື່ຜູ້ໃຊ້ ຫຼື ເບີໂທເພື່ອເຂົ້າສູ່ລະບົບ',
    ln_pass_title: 'ລະຫັດຜ່ານ', ln_pass_sub: 'ປ້ອນລະຫັດເຂົ້າລະບົບ', ln_next: 'ຕໍ່ໄປ', ln_back: 'ກັບຄືນ',
    ln_problem: 'ພົບບັນຫາ？', ln_contact_cs: 'ຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າ', ln_alert: 'ແຈ້ງເຕືອນ',
    ln_enter_user: 'ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້ ຫຼື ເບີໂທ', ln_wrong_cred: 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    rg_phone_title: 'ປ້ອນເບີໂທລະສັບ', rg_phone_sub: 'ລະບົບຈະສົ່ງລະຫັດ OTP ໃຫ້ທ່ານ', rg_referrer_ph: 'ຜູ້ແນະນຳ (ຖ້າມີ)',
    rg_otp_title: 'ຢືນຢັນ OTP', rg_otp_ph: 'ປ້ອນ OTP 4 ຫຼັກ', rg_bank_title: 'ປ້ອນເລກບັນຊີ', rg_select_bank: 'ກະລຸນາເລືອກບັນຊີທະນາຄານ',
    rg_verify1: 'ກະລຸນາກວດສອບ ຊື່ ແລະ ເລກບັນຊີ !!', rg_verify2: 'ຫາກບໍ່ຖືກຕ້ອງ ຈະບໍ່ສາມາດແກ້ໄຂ ຫຼື ຝາກຖອນໄດ້',
    rg_acc_ph: 'ປ້ອນເລກບັນຊີ', rg_name_ph: 'ປ້ອນ ຊື່-ນາມສະກຸນ (ພາສາໄທເທົ່ານັ້ນ)', rg_fill_warn: 'ປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນຖືກຕ້ອງ ບໍ່ດັ່ງນັ້ນຈະຖອນເງິນບໍ່ໄດ້',
    rg_pass_title: 'ຕັ້ງລະຫັດຜ່ານ', rg_pass_sub: 'ຕັ້ງລະຫັດຜ່ານສຳລັບເຂົ້າສູ່ລະບົບ (ຢ່າງໜ້ອຍ 6 ຕົວ)', rg_pass_ph: 'ລະຫັດຜ່ານ', rg_passcf_ph: 'ຢືນຢັນລະຫັດຜ່ານ',
    rg_continue: 'ຕໍ່ໄປ', rg_cancel: 'ຍົກເລີກ',
  },
};
Object.keys(_authExt).forEach((l) => { translations[l] = Object.assign({}, translations[l], _authExt[l]); });

export const t = (lang, key) => {
  return translations[lang]?.[key]
    ?? translations['th']?.[key]
    ?? key;
};

export default translations;